import { Injectable, Inject, Injector, ViewChild, ElementRef } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';

import { DatePipe } from '@angular/common';
import { Route } from '@angular/compiler/src/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

import * as CryptoJS from 'crypto-js';
import { ToastrService } from 'ngx-toastr';
import { DOCUMENT } from '@angular/common';
import { interval } from 'rxjs';
import { WebcamImage } from 'ngx-webcam';
declare let $: any;

@Injectable({
  providedIn: 'root'
})
export class AppService {
  public access_tocken = "";
  private sessionRestorePromise: Promise<boolean> | null = null;
  private _toastr: ToastrService | null = null;

  private formatDate(value: string | number | Date, format: string): string {
    return this.datePipe.transform(value, format) ?? '';
  }

  public Server_URL = "http://localhost:5837/";


  public Serial_No = "";
  public Job_Order_Number = "";
  // test 
  public INSType="All"
  gettime()
  {

  }
  public Inspector_Row = [];
  public test = '';
  get_stage(data: string) {
  this.test = data;
}
  public Home_page = '';

  public System_mac_address = "Not found"
  public Area_Map: boolean = false;

  public NT_Sales_Disp_Text1 = "Open Invoice";
  public ID = "";
  public Link = "";
  public CM_Name = "";
  public Emp_Email="";
  public Print_Type = "localhost";
  public Shift = "All";
  public CM_Email_ID = "";
  public Purchase_entry_page = "/Purchase/purchase-entry";
  public Sales_Disp_Text1 = "Open Invoice";
  public Sales_Disp_Text2 = "Open Invoice(with code)";
  public Sales_Disp_Text2_Visblle: boolean = false;
  public Sales_Disp_Text3_Visblle: boolean = false;
  public Loss_Min = 0;
  public TCS_Enable: boolean = true;
  public Balance_SMS = "false";

  public Sales_Entry_Page = "/sales/sales-entry";

  public key_value = "";

  public Machine_ID = "All";
  public NT_Printer: string = "false";
  public NT_Address: String = "http://localhost:5837/";

  public DB_Vadi_display: boolean = false;
  public Print_Button: boolean = false;

  public Ledger_Update: boolean = true;
  public Cust_Amt: boolean = false;
  public Lfrom = "34";
  public Top = 50;
  public Problem = "";
  public Logo_location = "Top_qubha";
  public Logo_Name = "SHRI KRISHNA ENGINEERING WORKS";
  public Logo_location_Loin = "Chef";
  public Logo_Sub_Name = "Soft";
  public Phone_No = "9597436220";

  public Cam_Type = "Proof";
  public Line_No = "All";

  public Proof_Image: any;
  public Visa_Image: any;
  public Empty_Image: any;

  public Qmenu: boolean = true;
  public STamilName: boolean = false;
  public Type_Based_Bill_No: boolean = false;
  public Item_Rate_Update: boolean = true;
  public Check_Stock: boolean = false;


  public Feed_Back_Link = "Thank you for your visit to Apollo Tyres Ltd, Chennai Plant. Click the link to share your visit feedback."

  public Image_disp: boolean = false;
  public Ledger_Type = "1";

  public Group_Enable: boolean = false;
  public Print_Bill: boolean = false;

  public Save_Print: boolean = false;
  public Save_Print_Mobile: boolean = false;
  public Save_New: boolean = false;

  public Stockbase_Sales: boolean = false;



  Lable_Order_entry = "Order Entry";
  Lable_Takeaway = "Takeaway";
  Lable_Dining = "Dining";
  Lable_Purchase = "Purchase";
  Lable_Sales = "Sales";
  Lable_Receipt = "Receipt";
  Lable_Payment = "Payment";
  Lable_Expence = "Expence";
  Lable_Daybook = "Day Book";
  Lable_Receivable = "Receivable";
  Lable_Payable = "Payable";
  Lable_Item_Master = "Item Master";
  Lable_Ledger = "LedgerMaster";
  Lable_Reports = "Reports";
  Lable_Minimum_Stock = "Minimum Stock";
  public T_Year = "";
  public T_Week = "";
  public PRate_disp = "user";
  public U_Rights = "";
  public Type = "All";
  public Item_Group_ = "1";
  public from_customer_page: boolean = false;
  public T_Month = ""
  public isadd_Page: boolean = false;
  public isShowPlayButton: boolean;
  public isPlayToggleShow: boolean;
  public Machine_Name: any;
  IsFilterShow: boolean;
  isGetStatusColor: any;
  public Packing_Line_No = [];
  public CompanyName = "Production Traceability";
  public fullscreenElement: any;
  public isFullScreen: boolean;
  constructor(@Inject(DOCUMENT) private document: Document, private injector: Injector, public datePipe: DatePipe, public http: HttpClient, public router: Router, private _location: Location) {
    this.loadRootConfig();

    if (this.getData()) {

      this.data = this.getData();
      this.setCurrentUser(this.data);

      try {
        this.Customer_Area = localStorage.getItem('Area');
      } catch { }

    }


    this.W_height = window.innerHeight;

    this.W_width = window.innerWidth;

    var Today_Date = this.formatDate(new Date(), "dd-MMM-yyyy");

    this.T_Date = this.formatDate(new Date(), "yyyy-MM-dd");
    this.T_Time = this.formatDate(new Date(), "HH:mm");

    this.T_Date_Time = this.formatDate(new Date(), "yyyy-MM-ddTHH:mm");

    this.T_Date_Time_ = this.formatDate(new Date(), "yyyy-MM-ddTHH:mm");


    this.T_Month = this.formatDate(new Date(), "MM");
    this.Pay_Date = this.formatDate(new Date(), "yyyy-MM-dd");

    this.T_Year = this.formatDate(new Date(), "yyyy");
    this.T_Week = this.formatDate(new Date(), "w");

    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    this.Y_Date = this.formatDate(yesterday, "dd-MMM-yyyy");
    this.Today_Date = Today_Date;



    this.S_From = this.formatDate(new Date(), "yyyy-MM-dd");
    this.S_To = this.formatDate(new Date(), "yyyy-MM-dd");

    this.From_Date = { formatted: Today_Date };
    this.To_Date = { formatted: Today_Date };
    this.Date = { formatted: Today_Date };
    this.Date1 = { formatted: Today_Date };

    this.Due_Date = this.formatDate(new Date(), "yyyy-MM-dd");

    this.load_themes('');


    interval(30000).subscribe(x => {
      this.T_Date_Time = this.formatDate(new Date(), "yyyy-MM-ddTHH:mm");

    });



    interval(16000).subscribe(x => {
      if (this.DB_Mode == "Play") {
        if (this.Page_No >= 3) {
          this.Page_No = -1;
        }
        this.Page_No = this.Page_No + 1;

        this.load_page(this.Dashboard_Menu[this.Page_No]["Link"])
      }
    });
  }

  private get toastr(): ToastrService {
    if (!this._toastr) {
      this._toastr = this.injector.get(ToastrService);
    }

    return this._toastr;
  }

  private loadRootConfig() {
    const appRoot = this.document.querySelector('app-root');

    if (!appRoot) {
      return;
    }

    const apiLocation = appRoot.getAttribute('API_Location');
    const ntPrinter = appRoot.getAttribute('NT_Printer');
    const ntAddress = appRoot.getAttribute('NT_Address');

    if (apiLocation) {
      this.Server_URL = apiLocation;
    }

    if (ntPrinter) {
      this.NT_Printer = ntPrinter;
    }

    if (ntAddress) {
      this.NT_Address = ntAddress;
    }
  }

  public setCurrentUser(user: any) {
    if (!user) {
      return;
    }

    this.data = user;
    this.Current_User = user;
    this.Company = "_" + user.UM_Company;
    this.Rights_Name = user.Rights || this.Rights_Name;
    this.Login_User = user.UM_User_Name || this.Login_User;

    localStorage.setItem('User_Data', JSON.stringify(user));
  }

  private clearStoredSession() {
    localStorage.removeItem('User_Data');
    localStorage.removeItem('U_Key');
    localStorage.removeItem('P_Key');
  }

  private async authenticateUser(userName: string, password: string): Promise<any | null> {
    const loginResponse: any = await this.http.post(this.Server_URL + 'Api/Common/GetLogin', {
      UserName: userName,
      Password: password
    }).toPromise();

    if (!loginResponse) {
      return null;
    }

    return JSON.parse(loginResponse).record[0];
  }

  public async loginWithCredentials(userName: string, password: string): Promise<boolean> {
    const loginRecord = await this.authenticateUser(userName, password);

    if (!loginRecord) {
      return false;
    }

    localStorage.setItem('U_Key', this.encryptData(userName));
    localStorage.setItem('P_Key', this.encryptData(password));
    this.setCurrentUser(loginRecord);

    await this.fetchAccessToken();
    await this.loadStartupData();

    return true;
  }

  public logout() {
    localStorage.clear();
    this.Current_User = {};
    this.Company = "";
    this.tocken = "";
    this.Menu_Rows = [];
    this.P_Menu_Rows = [];
    this.Label_Menu_Rows = [];
    this.Side_Menu = false;
    this.router.navigate(['/authentication/login'], { replaceUrl: true });
  }

  public initializeStoredSession(): Promise<boolean> {
    if (this.sessionRestorePromise) {
      return this.sessionRestorePromise;
    }

    this.sessionRestorePromise = this.restoreStoredSession()
      .then((isRestored) => {
        if (!isRestored) {
          this.clearStoredSession();
          this.Current_User = {};
          this.Company = "";
          this.Lab_Home_Page = "";
        }

        return isRestored;
      })
      .catch(() => {
        this.clearStoredSession();
        this.Company = "";
        this.Current_User = {};
        this.Lab_Home_Page = "";
        return false;
      })
      .finally(() => {
        this.sessionRestorePromise = null;
      });

    return this.sessionRestorePromise;
  }

  private async restoreStoredSession(): Promise<boolean> {
    const userData = this.getData();
    const savedUser = localStorage.getItem('U_Key');
    const savedPassword = localStorage.getItem('P_Key');

    if (!userData && (!savedUser || !savedPassword)) {
      return false;
    }

    if (userData) {
      this.setCurrentUser(userData);
    } else {
      const userName = this.decryptData(savedUser);
      const password = this.decryptData(savedPassword);

      if (!userName || !password) {
        return false;
      }

      const loginRecord = await this.authenticateUser(userName, password);

      if (!loginRecord) {
        return false;
      }

      this.setCurrentUser(loginRecord);
    }

    await this.fetchAccessToken();
    await this.loadStartupData();

    return true;
  }

  private async fetchAccessToken(): Promise<void> {
    const tokenResponse: any = await this.http.post(this.Server_URL + 'token', 'grant_type=password&UserName=admin&Password=admin', {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
    }).toPromise();

    this.tocken = tokenResponse['access_token'];
    this.head = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.tocken
    });
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.tocken
    });
  }

  private async loadStartupData(): Promise<void> {
    await Promise.all([
      this.loadFieldSettingsAsync(),
      this.loadMenuMasterAsync(),
      this.loadMachineAsync()
    ]);
  }

  private async loadFieldSettingsAsync(): Promise<void> {
    const response: any = await this.getc("Api/Setting/get_Field_Setting").toPromise();

    if (response == "No_Licence") {
      await this.router.navigate(['/invalid-licence']);
      return;
    }

    this.Field_Setting = JSON.parse(response).record;
    await this.loadSettingMasterAsync();
  }

  private async loadSettingMasterAsync(): Promise<void> {
    const response: any = await this.getc("Api/Common/Get_Setting_Master").toPromise();

    this.SM_Row = JSON.parse(response).record;

    try {
      for (var i = 0; i < this.SM_Row.length; i++) {
        this.get_variable_Value(this.SM_Row[i]["S_Variable"]);
      }
    } catch { }

    await this.loadDefaultsAsync();
  }

  private async loadDefaultsAsync(): Promise<void> {
    const response: any = await this.getc("Api/Master/get_reference").toPromise();

    this.Reference_Rows = JSON.parse(response).record;
    this.Reference_Rows.sort((a, b) => a["label"].localeCompare(b["label"]));

    this.Sales_Person = this.Current_User.UM_User_Name;
    this.CREATED_BY = this.Current_User.UM_User_Name;
    this.Rights_ID = this.Current_User.UM_Rights;
    this.Emp_ID = this.Current_User.Emp_ID;
    this.Emp_Name = this.Current_User.UM_Full_Name;

    await this.loadRoleRightsAsync(this.Current_User.UM_Rights);

    try {
      this.Prow = this.Reference_Rows.filter(e => e.Ref_ID == "User_Role");

      this.Rights_Name = this.Prow.filter(e => e.RGV_iID.toLowerCase() == this.Current_User.UM_Rights)[0].RGV_vDesciption;
      this.U_Rights = this.Rights_Name.toLowerCase();
      this.Header_Disp = this.Current_User.CM_Name;

      if (!(this.Rights_Name.toLowerCase() == "admin")) {
        this.Search_User = this.Current_User.UM_User_Name;
      }
    } catch { }

    try {
      this.page = this.Prow.filter(e => e.RGV_iID.toLowerCase() == this.Current_User.UM_Rights)[0].RGV_vCode;
      this.Lab_Home_Page = this.page;
    } catch (e) {
      console.log(e);
    }
  }

  private async loadRoleRightsAsync(role: string): Promise<void> {
    const response: any = await this.get("Api/Setting/get_Menu_for_user?Rights=" + role).toPromise();

    this.applyRoleRights(response);
  }

  private applyRoleRights(response: any) {
    this.Menu_Rows = JSON.parse(response).record;
    this.P_Menu_Rows = JSON.parse(response).record;

    this.Side_Menu = true;

    try {
      this.Label_Menu_Rows = this.Menu_Rows.filter(e => e.Type == "Label");
      this.Label_Menu_Rows = this.Label_Menu_Rows.filter(e => e.Parent_ID == "0");
      this.Label_Menu_Rows.sort((a, b) => Number(a["Order_No"]) - Number((b["Order_No"])));
    } catch { }
  }

  private async loadMenuMasterAsync(): Promise<void> {
    const response: any = await this.getc("Api/Setting/get_Menu_master").toPromise();

    this.applyMenuMaster(response);
  }

  private applyMenuMaster(response: any) {
    this.Menu_Master_Rows = JSON.parse(response).record;
    this.Parent_Menus = this.Menu_Master_Rows.filter(e => e.Parent_ID == "0");
  }

  private async loadMachineAsync(): Promise<void> {
    const response: any = await this.getc("Api/master/get_Machine_Name_All").toPromise();

    this.Machine_Row = JSON.parse(response).record;
  }

  get_image_Name() {
    return this.formatDate(new Date(), "yyyy_MM_dd_HH_mm_sss");
  }

  FTQ_Issue_Row = [];
  get_FTQ_Issue_Details() {
    this.isload = true;
    this.get("Api/master/get_FTQ_Issue_Details?From=" + this.S_From + "&To=" + this.S_To).subscribe((res: any) => {
      this.isload = false;
      this.FTQ_Issue_Row = JSON.parse(res).record;
    });
  }

  Conatinment_row = [];
  get_ConatinmetDetails() {
    this.isload = true;
    this.get("Api/master/get_Containment_Details?From=" + this.S_From + "&To=" + this.S_To+"&Status="+this.Continament_status).subscribe((res: any) => {
      this.isload = false;
      this.Conatinment_row = JSON.parse(res).record;
    });
  }
  FTQ_Status_Row = [];
  get_FTQ_Ststaus_Details() {
    this.isload = true;
    this.get("Api/transaction/get_FTQ_Status_Details?From=" + this.S_From + "&To=" + this.S_To).subscribe((res: any) => {
      this.isload = false;
      this.FTQ_Status_Row = JSON.parse(res).record;
    });
  }


  PartsConatamation_Row = [];
  get_PartsConatamation_Details() {
    this.isload = true;
    this.get("Api/transaction/get_PartsConataimation_Details?From=" + this.S_From + "&To=" + this.S_To).subscribe((res: any) => {
      this.isload = false;
      this.PartsConatamation_Row = JSON.parse(res).record;
    });
  }

  GearBox_Contamination_Row = [];
  get_GearBox_Contamination_Level() {
    this.isload = true;
    this.get("Api/transaction/get_Gearbox_Level_Details?From=" + this.S_From + "&To=" + this.S_To).subscribe((res: any) => {
      this.isload = false;
      this.GearBox_Contamination_Row = JSON.parse(res).record;
    });
  }


  FTQ_Status_Row__ = [];
  Tracebility=0;
  Incoming=0;
  FTQ=0;

  get_FTQ_Status_Details() {
   
    this.isload = true;
    this.get("Api/transaction/get_FTQ_Status_Details?From=" + this.S_From + "&To=" + this.S_To).subscribe((res: any) => {
      this.isload = false;
      this.FTQ_Status_Row__ = JSON.parse(res).record;
      try{
        this.Tracebility=0;
        this.Incoming=0;
        this.FTQ=0;
    this.Tracebility=this.FTQ_Status_Row__.reduce((sum,current) => sum + parseFloat(current.Tracebility_Rej),0).toFixed(0);
    this.Incoming=this.FTQ_Status_Row__.reduce((sum,current) => sum + parseFloat(current.Incoming_Rej),0).toFixed(0);
    this.FTQ=(this.FTQ_Status_Row__.reduce((sum,current) => sum + parseFloat(current.FTQ_Per),0)).toFixed(2);

      }
      catch{

      }
    });

  }


  public Assembly_Verification_Circlip_Marking_Details_Rows = [];
  get_Assembly_Verification_Circlip_Marking_Details() {
    this.isload = true;
    this.Assembly_Verification_Circlip_Marking_Details_Rows = [];
    this.get("Api/Transaction/get_Assembly_Verification_Circlip_Marking_Details?From=" + this.S_From + "&To=" + this.S_To).subscribe((res: any) => {
      this.Assembly_Verification_Circlip_Marking_Details_Rows = JSON.parse(res).record;
      this.isload = false;
    });
  }

  public Assembly_Verification_Paint_Marking_Details_Rows = [];
  get_Assembly_Verification_Paint_Marking_Details() {
    this.isload = true;
    this.Assembly_Verification_Paint_Marking_Details_Rows = [];
    this.get("Api/Transaction/get_Assembly_Verification_Paint_Marking_Details?From=" + this.S_From + "&To=" + this.S_To).subscribe((res: any) => {
      this.Assembly_Verification_Paint_Marking_Details_Rows = JSON.parse(res).record;
      this.isload = false;
    });
  }
  public Bolt_Torque_Check_Status_Details_Rows = [];
  get_Bolt_Torque_Check_Status_Details() {
    this.isload = true;
    this.Bolt_Torque_Check_Status_Details_Rows = [];
    this.get("Api/Transaction/get_Bolt_Torque_Check_Status_Details?From=" + this.S_From + "&To=" + this.S_To).subscribe((res: any) => {
      this.Bolt_Torque_Check_Status_Details_Rows = JSON.parse(res).record;
      this.isload = false;
    });
  }
  public Grease_Calibration_Details_Rows = [];
  get_Grease_Calibration_Details() {
    this.isload = true;
    this.Grease_Calibration_Details_Rows = [];
    this.get("Api/Transaction/get_Grease_Calibration_Details?From=" + this.S_From + "&To=" + this.S_To).subscribe((res: any) => {
      this.Grease_Calibration_Details_Rows = JSON.parse(res).record;
      this.isload = false;
    });
  }

  public kayaba_Vision_Status_Details_Rows = [];
  get_kayaba_Vision_Status_Details() {
    this.isload = true;
    this.kayaba_Vision_Status_Details_Rows = [];
    this.get("Api/Transaction/get_kayaba_Vision_Status_Details?From=" + this.S_From + "&To=" + this.S_To).subscribe((res: any) => {
      this.kayaba_Vision_Status_Details_Rows = JSON.parse(res).record;
      this.isload = false;
    });
  }
  public lubrication_Oil_Filling_Verification_Details_Rows = [];
  get_lubrication_Oil_Filling_Verification_Details() {
    this.isload = true;
    this.lubrication_Oil_Filling_Verification_Details_Rows = [];
    this.get("Api/Transaction/get_lubrication_Oil_Filling_Verification_Details?From=" + this.S_From + "&To=" + this.S_To).subscribe((res: any) => {
      this.lubrication_Oil_Filling_Verification_Details_Rows = JSON.parse(res).record;
      this.isload = false;
    });
  }

  public PCA_Verification_Details_Rows = [];
  get_PCA_Verification_Details() {
    this.isload = true;
    this.PCA_Verification_Details_Rows = [];
    this.get("Api/Transaction/get_PCA_Verification_Details?From=" + this.S_From + "&To=" + this.S_To).subscribe((res: any) => {
      this.PCA_Verification_Details_Rows = JSON.parse(res).record;
      this.isload = false;
    });
  }
  public Oil_Calibration_Details_Rows = [];
  get_Oil_Calibration_Details() {
    this.isload = true;
    this.Oil_Calibration_Details_Rows = [];
    this.get("Api/Transaction/get_Oil_Calibration_Details?From=" + this.S_From + "&To=" + this.S_To).subscribe((res: any) => {
      this.Oil_Calibration_Details_Rows = JSON.parse(res).record;
      this.isload = false;
    });
  }
public Sheet_Type="";
  public Oil_Contamination_Level_Rows = [];
  get_Oil_Contamination_Level() {
    this.Oil_Contamination_Level_Rows = [];
    this.isload = true;
    this.get("Api/Transaction/get_Oil_Contamination_Details?From=" + this.S_From + "&To=" + this.S_To + "&Type=" + this.Type).subscribe((res: any) => {
      this.Oil_Contamination_Level_Rows = JSON.parse(res).record;
      this.isload = false;
    });
  }

  public Plug_Torque_Check_Status_Details_Rows = [];
  get_Plug_Torque_Check_Status_Details() {
    this.isload = true;
    this.Plug_Torque_Check_Status_Details_Rows = [];
    this.get("Api/Transaction/get_Plug_Torque_Check_Status_Details?From=" + this.S_From + "&To=" + this.S_To).subscribe((res: any) => {
      this.Plug_Torque_Check_Status_Details_Rows = JSON.parse(res).record;
      this.isload = false;
    });
  }
  public Poka_Yoke_Verification_Details_Rows = [];
  get_Poka_Yoke_Verification_Details() {
    this.isload = true;
    this.Poka_Yoke_Verification_Details_Rows = [];
    this.get("Api/Transaction/get_Poka_Yoke_Verification_Details?From=" + this.S_From + "&To=" + this.S_To).subscribe((res: any) => {
      this.Poka_Yoke_Verification_Details_Rows = JSON.parse(res).record;
      this.isload = false;
    });
  }
  Page_No = -1
  Display = "collapse";
  DB_Mode = "Pause";
  Current_Time = "";

  Next_Page() {

    this.Page_No = this.Page_No + 1;

    if (this.Page_No > 3) {
      this.Page_No = 0;
    }

    this.load_page(this.Dashboard_Menu[this.Page_No]["Link"])
  }



  Previous_Page() {

    this.Page_No = this.Page_No - 1;

    if (this.Page_No <= 0) {
      this.Page_No = 0;
    }


    this.load_page(this.Dashboard_Menu[this.Page_No]["Link"])
  }

  public openModal: boolean = false;
  Open_Modal(Title: string, page: string) {
    this.openModal = true;
    $('#small_Module').modal('show');
  }

  Close_Modal() {
    this.openModal = false;
    $('#small_Module').modal('hide');
  }

  get_time() {
    this.T_Date_TimeD = this.formatDate(new Date(), "dd-MM-yyyy hh:mm ");
  }

  public SM_Row = [];
  public Header_Disp = "";
  public Issue_Status = "All";
  public Req_Type = "All";

  public add_item_name = "/add-items1";
  btndisable: boolean = false;
  isload: boolean = false;
  public Company = "";
  public CREATED_BY = "";
  public Ref_ID = "0";
  public isadd = "0";
  public Edit_Row: any = {};
  public Continue_Row: any = null;
  public Selected_Row: any = {};
  public Default_ref_ID: string = "Department";
  public URL_Location = "";
  public Hotel_Reprint = "false";

  public Condi_Sales = "";

  public Loss_Details_GF = ['Model_No', 'Line_No', 'Loss_Type', 'Loss_Minute', 'Shift'];
  public Torque_Details_GF = ['Short_Name', 'Name', 'Torque_Name', 'Shift', 'Set_Value', 'Measured_Value', 'Serial_No', 'Torque_Gun', 'Result'];
  public Material_Requst_Details_GF = ['Request_Time', , 'Part_No', 'Part_Desc', 'Station_No', 'Issue_Status', 'Request_Time']
  public disp_category: boolean = false;

  public Sales_Entry_Row_width =
    {
      ID: "5%",
      Code: "10%",
      Name: "23%",
      Desc: "17%",
      Rate: "15%",
      Qty: "15%",
      Amount: "15%"
    };
  public Model_No = "All"


  public SER_Disp =
    {
      ID: true,
      Code: false,
      Name: true,
      Desc: true,
      Rate: true,
      Qty: true,
      Amount: true
    };

    Continament_status="Pending";

  public Sales_Temp_Row: any = {};
  public Sales_Temp_Row1 = [];
  public Proforma_Details_GF = ['Customer_Name', 'Bill_No'];
  public BOM_Master_GF = [];

  public Quatation_Details_GF = [];



  public Visitor_Master_GF = ['Contact_No'];
  public Reprint_Packing_GF = ['Box_Barcode', 'Part_No', 'Qty', 'Operator_code', 'Name'];
  public Reprint_Lable_GF = ['Delivery_No', 'Material_Code', 'Barcode', 'Qty', 'Name'];
  public Item_Master_GF = ['Model_No', 'Part_No', 'Part_Desc', 'Cycle_Time'];
  public Waiting_For_Packing_GF = ['Part_No', 'Serial_No', 'Pro_Date', 'Packing_Status'];
  public Today_Packing_GF = ['Date', 'Part_No', 'Rack_No', 'Qty'];
  public Stock_At_Rate_GF = ['Date', 'Part_No', 'GB_Serial_No', 'Rack_No', 'Qty'];
  public Machine_Torque_GF = ['Machine_ID', 'Torque_Name', 'Torque_Description'];
  public Station_GF = ['Station_Name'];
  public Sequence_GF = ['Name'];
  public Gear_Box_Dispatched_GF = ['Invoice_No', 'Invoice_Date', 'Item_Name', 'Billed_Qty', 'Scanned_Qty'];
  public Gear_Box_Return_GF = ['Serail_No', 'Model_No', 'Description', 'Issue_by', 'Issued_To'];

  public WTF_Printing_GF = ['Delivery_No', 'Line_Items', 'Material_Code', 'Plant', 'Qty'];
  public Pending_Invoice_GF = ['Invoice_No', 'Invoice_Date', 'Item_Name', 'Description', 'Billed_Qty'];
  public Gear_Box_GF = ['Uni_Serial_No', 'Invoice_No', 'Date', 'Part_No', 'Storage', 'Operator_Code', 'Box_Size', 'VCN_Cover', 'Customer_Code', 'Box_Barcode', 'loose_kit_Box', 'Visual_Inspection_Remarks', 'Dis_Status', 'Customer_Name',];
  public Pending_DC_GF = ['DC_No', 'DC_Date', 'Material_Code', 'Billed_Qty', 'Scanned_Qty'];
  public WTF_Dispatched_GF = ['Pack_Date', 'Packing_No', 'Part_No', 'DO_No', 'DC_OK_ID'];
  public Product_Master_GF = [];
  public Purchase_Master_GF = [];
  public Stock_Adjustment_GF = [];
  public Blocked_Visitor_GF = [];
  public Area_Master_GF = [];
  public Purchase_Order_Details_GF = [];
  public Member_Details_GF = [];
  public Area_Street_Details_GF = [];
  public Production_Details_GF = [];
  public Employee_Details_GF = ['Contact_No', 'Code', 'Name', 'Department', 'Designation'];


  public Packing_Details_GF = ['Part_No', 'Customer_Name', 'Box_Size', 'Box_Barcode', 'Invoce_N0'];
  public Vadi_Details_GF = [];
  public Holiday_Details_GF = [];
  public Menu_Master_GF = ['Module', 'Type', 'Display_Name', 'Route_Link', 'Order_No', 'Icon', 'Remark'];
  public Module_Master_GF = ['Module_Name', 'S_No', 'Module_Desc'];

  public Expense_Details_GF = ['Category_', 'Narration1', 'Amount'];
  public Contra_Details_GF = ['Naration', 'Amount'];

  public Sales_Details_GF = ['Customer_Name', 'Bill_No', 'Area'];
  public Delivery_Details_GF = ['Customer_Name', 'DC_No'];

  public Tharikar_Detail_GF = ['Customer_Name', 'Bill_No'];
  public Dyeing_Detail_GF = ['Customer_Name', 'Bill_No'];


  public Damage_Details_GF = ['Customer_Name', 'Damage_No'];
  public Minimum_Stock_GF = ['Item_Name', 'Stock', 'Ledger_name', 'Reorder_Level', 'Min_stock'];

  public Sales_Return_Details_GF = ['Customer_Name', 'Bill_No'];
  public Billwise_Purchase_GF = ['Supplier_Name', 'Bill_No', 'Bill_Date', 'Phone_No', 'Amount'];
  public Customerwise_GF = ['Customer_Name', 'Bill_No', 'Bill_Date', 'Area', 'Phone_No', 'Amount'];
  public Billwise_Track_GF = ['Bill_No', 'Bill_Date', 'Profit', 'P_Value', 'S_Value', 'Supplier'];
  public Itemwise_Track_GF = ['Item_Name', 'P_Qty', 'S_Qty', 'Stock_Qty', 'Profit', 'P_Value', 'S_Value', 'Stock_Value'];
  public Supplierwise_Track_GF = ['Supplier', 'S_Value', 'Profit', 'Stock_Value', 'P_Value'];
  public Categorywise_Track_GF = ['Category', 'P_Qty', 'S_Qty', 'Stock_Qty', 'Profit', 'P_Value', 'S_Value', 'Stock_Value'];
  public Price_List_GF = ['Category', 'Item_Name', 'MRP', 'Rate', 'Wholesale_Rate'];
  public Cash_Settlement_GF = ['Cash_Amt', 'Card_Amt', 'Bill_No', 'Bill_Date', 'Cheque_Amt', 'Credit_Amt,', 'Less_Amt'];

  public Track_GF = ['Item_Name', 'Supplier', 'Bill_No', 'Bill_Date', 'Profit', 'S_Value', 'P_Value'];
  public Visitor_GF = ['Visitor_Name', 'V_From_Time', 'Visitior_Status', 'Company_Name', 'Purpose', 'V_Person'];
  public Approved_GF = ['Visitor_Name', 'V_From_Time', 'Visitior_Status', 'Company_Name', 'Purpose', 'V_Person'];
  public Visitorwise_GF = ['Visitor_Name', 'Card_No', 'Contact_No', 'Vistor_Type', 'Company_Name', 'V_Department', 'V_Person'];

  public Search_GF = ['Visitor_Name', 'Contact_No', 'Vistor_Type', 'Company_Name', 'V_Department', 'V_Person'];
  public Departmentwise_GF = ['Visitor_Name', 'Vistor_Type', 'Company_Name', 'V_Department', 'V_Person'];
  public Personwise_GF = ['Visitor_Name', 'Vistor_Type', 'Company_Name', 'V_Department', 'V_Person'];
  public Purposewise_GF = ['Visitor_Name', 'Vistor_Type', 'Company_Name', 'V_Department', 'V_Person'];
  public Daywise_GF = ['V_From_Time', 'Vistor_Type', 'Company_Name', 'V_Department', 'V_Person'];

  public Billwise_Sales_GF = ['Customer_Name', 'Bill_No', 'Bill_Date', 'Phone_No', 'Amount'];
  public Delivery_Detail_GF = ['Customer_Name', 'Item_Name', 'Bill_No', 'Bill_Date', 'Phone_No', 'Amount'];

  public Billwise_Profit_GF = ['Customer_Name', 'Bill_No', 'Bill_Date', 'Phone_No', 'Amount', 'Profit'];
  public Itemwise_Purchase_GF = ['Item_Name', 'Amount', 'Qty'];
  public Productwise_Sales_GF = ['Item_Name', 'Amount', 'Qty'];

  public Itemwise_Sales_GF = ['Item_Name', 'Amount', 'Qty'];
  public Itemwise_Profit_GF = ['Item_Name', 'Amount', 'Qty', 'Profit'];
  public Userwise_Purchase_GF = ['User', 'Amount', 'count'];

  public Userwise_Sales_GF = ['User', 'Amount', 'count'];
  public Entrywise_col_GF = ['Ledger_Name', 'Bill_No', 'Amount', 'Receipt_No'];
  public Day_book_GF = ['Nar_Type', 'Created_by', 'Pay_Mode_', 'CR_AMT'];
  public Print_Bar_GF = ['Item_Name', 'Description', 'Uni_Code'];
  public Reason_Master_GF = ['Reason_Code', 'Reason_Name'];

  public Machine_Standard_Config_GF = ['Parameter_Name', 'Set_Value'];
  public Daybook_Amt_GF = ['Bank', 'Amount'];

  public Customer_ledger_GF = ['Customer_Name', 'Phone_No', 'Bill_No', 'Net_Amt'];
  public Billwise_out_GF = ['Customer_Name', 'Amount', 'Phone_No'];
  public Billwisepayable_out_GF = ['Customer_Name', 'Amount', 'Phone_No'];
  public Responsibility_GF = ['Responsibility', 'count'];
  public Search_Name = "";
  public Customerwise_out_GF = ['Customer_Name', 'Amount', 'Phone_No'];
  public Supplierwise_out_GF = ['Customer_Name', 'Amount', 'Phone_No'];

  public Areawise_out_GF = ['Area', 'Amount', 'count'];
  public Streetwise_out_GF = ['Street', 'Amount', 'count'];



  public Arearwise_Purchase_GF = ['Area', 'Amount'];

  public Paymodewise_sales_GF = ['Pay_Mode', 'Amount'];
  public Paymodewise_Purchase_GF = ['Pay_Mode', 'Amount'];
  public Supplierwise_purchase_GF = ['Supplier_Name', 'count', 'Amount'];

  public Customerwise_sales_GF = ['Customer_Name', 'count', 'Amount'];
  public Customerwise_Profit_GF = ['Customer_Name', 'count', 'Amount', 'Profit'];
  public Category_stock_GF = ['Category', 'Stock', 'Value'];

  public Current_stock_GF = ['Item_Name', 'Description', 'Category', 'Rate', 'Stock', 'Value', 'MRP'];
  public Itemwise_stock_GF = ['Vour_Type', 'Voucher_No', 'Voucher_Date_', 'Rate'];
  public Stock_report_GF = ['Item_Name', 'Category', 'Opening', 'Rate', 'Inward', 'Outward', 'Closing'];
  public Product_Plan_GF = ['ModelNo', 'Machine_ID', 'Plan_Qty', 'Part_No', 'Plan_Shift'];

  public Track_Report = [
    { Menu: 'Billwise', Link: '/report/billwise-track', class: '' },
    { Menu: 'Itemwise', Link: '/report/itemwise-track', class: '' },
    { Menu: 'Supplierwise', Link: '/report/supplier-track', class: '' },
    { Menu: 'Categorywise', Link: '/report/category-track', class: '' },
    { Menu: 'Track Details', Link: '/report/product-track', class: '' },

  ];
  public Receiving_Approval_Report = [
    { Menu: 'Approved Checksheet', Link: '/transaction/approved-check-sheet', class: '' },

  ];
  public Inspection_Approval_Report = [
    { Menu: 'Inspection Approval', Link: '/transaction/inspection-approval', class: '' },

  ];

  public Delivery_Report = [
    { Menu: 'Customerwise', Link: '/report/delivery-details', class: '' },
    { Menu: 'Productwise', Link: '/report/product-wise', class: '' },
    { Menu: 'Brandwise', Link: '/report/brandwise-sales', class: '' },


  ];




  public User_Role_Menu = [
    { Menu: 'User Master', Link: 'settings/user-master' },
    { Menu: 'Role Master', Link: 'settings/role-master' },
    { Menu: 'Role Rights', Link: 'settings/role-rights' }

  ];

  public Ledger_Report = [
    { Menu: 'Day Book', Link: '/report/day-book', class: '' },
    { Menu: 'Customer Ledger', Link: '/report/customer-ledger', class: '' },
    { Menu: 'Supplier Ledger', Link: '/report/supplier-ledger', class: '' }

  ];




  public Email_Export = [

    { Field: 'Department', Name: 'Department', Align: '' },
    { Field: 'Email_ID', Name: 'Email ID', Align: '' },


  ];


  public Reason_Master_Export = [
    { Field: 'Reason_Code', Name: 'Reason Code', Align: '' },
    { Field: 'Reason_Name', Name: 'Reason Name', Align: '' },
  ];

  public Departmentwise_Export = [
    { Field: 'V_Department', Name: 'Department', Align: '' },


    { Field: 'count', Name: 'No of Visitor', Align: '' },


  ];



  public Rework_details_GF = ['Job_Order', 'FG_Code', 'Serial_No', 'Wheel_No', 'Operator_Name', 'Defect_Category'];
  public Quality_NG_details_GF = ['Part_No', 'Job_Order_No', 'Job_Order_Qty', 'Model_No', 'Serial_No', 'OP_Code', 'OP_Name'];
  public Block_Model_GF = ['Job_Order', 'FG_Code', 'Serial_No', 'Wheel_No', 'Operator_Name', 'Defect_Category'];
  public Unblock_Model_GF = ['Model_No', 'Serial_No', 'Block_Type', 'Block_Reason', 'Requested_by'];
  public Rework_Station_details_GF = ['Job_Order', 'FG_Code', 'FG_Code', 'Qty', 'Family', 'Serial_No', 'Date', 'Operator_Name', 'Defect_Category', 'Defect_Description', 'Final_Result'];
  public Ledger_Master_GF=['Code','Ledger_Name','Short_Name','Phone_Number'];

  public Ledger_Details_Export=[
    { Field: 'Code', Name: 'Supplier Code', Align: '' },
    { Field: 'Ledger_Name', Name: 'Supplier Name', Align: '' },
    { Field: 'Short_Name', Name: 'Short Name', Align: '' },
    { Field: 'Phone_Number', Name: 'Phone No', Align: '' },
    { Field: 'GSTIN', Name: 'GSTIN', Align: 'right' },
    { Field: 'PAN_No', Name: 'PAN No', Align: 'right' },
    { Field: 'Address1', Name: 'Address', Align: 'right' },
    { Field: 'Address2', Name: '', Align: 'right' },
    { Field: 'Address3', Name: '', Align: 'right' },
    { Field: 'State', Name: 'State', Align: 'right' },
    { Field: 'Country', Name: 'Country', Align: 'right' },
    { Field: 'Pincode', Name: 'Pincode', Align: 'right' },
    { Field: 'Area', Name: 'Area', Align: 'right' }

  ];
  public Delivery_Details_Export = [

    { Field: 'Bill_No', Name: 'Bill No', Align: '' },
    { Field: 'Bill_Date', Name: 'Date', Align: '' },
    { Field: 'Customer_Name', Name: 'Customer Name', Align: '' },
    { Field: 'Phone_No', Name: 'Phone No', Align: '' },
    { Field: 'Amount', Name: 'Amount', Align: 'right' }

  ];



  public Check_Employe_Report = [
    { Menu: 'Defect Details', Link: '/report/defect-details' },
    { Menu: 'Problemwise', Link: '/report/problemwise-report' },

    { Menu: 'Responsibilitywise', Link: '/report/responsibilitywise-report' }
  ];

  public Communication_Menu = [
    { Menu: 'WhatsApp', Link: '/settings/whatsapp-setting' },
    { Menu: 'Mail', Link: '/settings/gmail-setting' },
    // { Menu: 'SMS', Link: '/settings/sms-setting' },
    { Menu: 'Message', Link: '/settings/message' },

  ];
  public Supplierwise_purchase_Export = [
    { Field: 'Supplier_Name', Name: 'Supplier Name', Align: '' },
    { Field: 'count', Name: 'Count', Align: '' },
    { Field: 'Amount', Name: 'Amount', Align: 'right' },


  ];
  public Customerwise_Profit_Export = [
    { Field: 'Customer_Name', Name: 'Customer Name', Align: '' },
    { Field: 'count', Name: 'Count', Align: '' },
    { Field: 'Amount', Name: 'Amount', Align: 'right' },
    { Field: 'Profit', Name: 'Profit', Align: 'right' }


  ];




  public Item_Master_Export = [
    { Field: 'Part_No', Name: 'Part No', Align: '' },
    { Field: 'Part_Name', Name: 'Part Name', Align: '' },
    { Field: 'Family', Name: 'Family', Align: '' },
    { Field: 'Cycle_Time', Name: 'Cycle Time', Align: '' },
    { Field: 'Grade', Name: 'Grade', Align: '' },
    { Field: 'Drawing_No', Name: 'Drawing No', Align: '' },
    { Field: 'Revision_No', Name: 'Revision No', Align: '' },
    { Field: 'TPS_No', Name: 'TPS No', Align: '' },
    { Field: 'TPS_Revision_No', Name: 'TPS Revision No', Align: '' },
    { Field: 'ST_TPS', Name: 'ST TPS', Align: '' },
    { Field: 'ST_TPS_Revision_No', Name: 'ST TPS Revision No', Align: '' },

  ];
  public Sequence_Export = [
    { Field: 'Name', Name: 'Name', Align: 'center' },

  ];

  public Station_Export = [
    { Field: 'Station_Name', Name: 'Station Name', Align: 'center' },
  ];

  public Over_Due_Export = [
    { Field: 'Box_Barcode', Name: 'Box Barcode', Align: '' },
    { Field: 'Date', Name: 'Date', Align: '' },
    { Field: 'Days', Name: 'Days', Align: '' },
    { Field: 'Part_No', Name: 'Part No', Align: '' },
    { Field: 'Gross_wt', Name: 'Gross wt', Align: '' },
    { Field: 'Qty', Name: 'Qty', Align: '' }
  ];




  public Packing_Details_Export = [
    { Field: 'Date', Name: 'Date', Align: '' },
    { Field: 'Part_No', Name: 'Part_No', Align: '' },
    { Field: 'Part_Desc', Name: 'Part Desc', Align: '' },
    { Field: 'Gross_Wt', Name: 'Gross Wt', Align: '' },
    { Field: 'Customer_Name', Name: 'Customer Name', Align: '' },
    { Field: 'Box_Size', Name: 'Box Size', Align: '' },
    { Field: 'Uni_Serial_No', Name: 'Uni Serial_No', Align: '' },
    { Field: 'loose_Kit', Name: 'loose Kit', Align: '' },
    { Field: 'Customer_Code', Name: 'Customer_Code', Align: '' },
    { Field: 'Box_Barcode', Name: 'Box_Barcode', Align: 'right' },
    { Field: 'Print_Status', Name: 'Print_Status', Align: '' },
    { Field: 'Storage', Name: 'Storage', Align: '' },
    { Field: 'Dis_Status', Name: 'Dis Status', Align: '' },
    { Field: 'Invoice_No', Name: 'Invoice_No', Align: '' }
  ];


  public gear_Box_wtf_Export = [
    { Field: 'Invoice_No', Name: 'Invoice No', Align: '' },
    { Field: 'Invoice_Date', Name: 'Invoice Date', Align: '' },
    { Field: 'Item_Name', Name: 'Item Name', Align: '' },
    { Field: 'Description', Name: 'Description', Align: '' },
    { Field: 'Billed_Qty', Name: 'Billed_Qty', Align: '' },
    { Field: 'Scanned_Qty', Name: 'Scanned_Qty', Align: '' },


  ];
  public Gear_Box_Export = [
    { Field: 'Date', Name: 'Pack Date', Align: '' },
    { Field: 'Operator_Code', Name: 'Operator Name', Align: '' },
    { Field: 'Part_No', Name: 'Part Code', Align: '' },
    { Field: 'Part_Desc', Name: 'Part Description', Align: '' },

    { Field: 'Customer_Name', Name: 'Customer Name', Align: '' },
    { Field: 'Customer_Part_No', Name: 'Customer Part No', Align: '' },
    { Field: 'Customer_Barcode', Name: 'Customer Barcode', Align: '' },
    { Field: 'Gross_Wt', Name: ' Box Gross Wt', Align: '' },



    { Field: 'Box_Size', Name: 'Box Size', Align: '' },
    { Field: 'Uni_Serial_No', Name: 'Uni Serial_No', Align: '' },
    { Field: 'Moto_Name_Plate', Name: 'Motor Serial No', Align: '' },
    { Field: 'loose_kit_Box_Model', Name: 'loose Kit Part Code', Align: '' },
    { Field: 'loose_Kit_Box', Name: 'looseKit SerialNo', Align: '' },
    { Field: 'loose_kit_Pouch_Model', Name: 'loose_kit Pouch Partcode', Align: '' },
    { Field: 'loose_kit_Pouch', Name: 'loose_kit Pouch Serial No', Align: '' },

    { Field: 'Loose_Kit_Weight', Name: 'LooseKit Box Wt', Align: '' },

    { Field: 'VCN_Cover', Name: 'VCI Cover Presence', Align: '' },
    { Field: 'Visual_Inspection', Name: 'Visual Inspection', Align: '' },

    { Field: 'Visual_Inspection_Remarks', Name: 'Visual Inspection Remarks', Align: '' },
    { Field: 'Customer_Item_Code', Name: 'Customer PartCode', Align: '' },

    { Field: 'Box_Barcode', Name: 'Box No', Align: 'right' },
    { Field: 'Invoice_No', Name: 'Invoice No', Align: '' },

    { Field: 'Dis_Status', Name: 'Dis Status', Align: '' },

    { Field: 'Dis_Date', Name: 'Dis Date', Align: '' },
    { Field: 'Customer_Code', Name: 'Sold To Party', Align: '' },
    { Field: 'Deleted_by', Name: 'Deleted by', Align: '' },
    { Field: 'Reason_For_Delete', Name: 'Reason for Deleted', Align: '' },
    { Field: 'Pack_Type', Name: 'Pack Type', Align: '' },

    { Field: 'INV_OK_ID', Name: 'Dispatched Confirmation ID', Align: '' },
  ];



  public OP_58_report_Export = [
    { Field: 'Job_Order_No', Name: 'Job Order No', Align: '' },
    { Field: 'Job_Serial_No', Name: 'Job Serial No', Align: '' },
    { Field: 'Model_No', Name: 'Model No', Align: '' },
    { Field: 'Pallet_No', Name: 'Pallet No', Align: '' },

    { Field: 'Model_Desc', Name: 'Model Desc', Align: '' },
    { Field: 'Operator_Code', Name: 'Operator Code', Align: '' },
    { Field: 'Operator_Name', Name: 'Operator Name', Align: '' },
    { Field: 'Start_Date', Name: ' Start Date', Align: '' },



    { Field: 'End_Date', Name: 'End Date', Align: '' },
    { Field: 'Axial_Play_A', Name: 'Axial Play A', Align: '' },
    { Field: 'Axial_Play_B', Name: 'Axial Play B', Align: '' },
    { Field: 'Axial_Play', Name: 'Axial Play', Align: '' },
    { Field: 'Reduction_Kit1_No', Name: 'Reduction Kit1 No', Align: '' },
    { Field: 'Reduction_Kit2_No', Name: 'Reduction Kit2 No', Align: '' },
    { Field: 'Top_Cover', Name: 'Top Cover', Align: '' },

    { Field: 'Oring_Status', Name: 'Oring Status', Align: '' },

    { Field: 'Job_1_Pro', Name: 'Job 1 Pro', Align: '' },
    { Field: 'Job_1_Result', Name: 'Job_1_Result', Align: '' },

    { Field: 'Job_2_Pro', Name: 'Job_2_Pro', Align: '' },
    { Field: 'Job_2_Result', Name: 'Job_2_Result', Align: '' },

    { Field: 'Job_3_Pro', Name: 'Job_3_Pro', Align: '' },
    { Field: 'Job_3_Result', Name: 'Job_3_Result', Align: '' },

    { Field: 'job_4_No', Name: 'job_4_No', Align: '' },

    { Field: 'Job_4_Result', Name: 'Job_4_Result', Align: '' },
    { Field: 'Final_Result', Name: 'Final_Result', Align: '' },
    { Field: 'Status', Name: 'Status', Align: '' },

    { Field: 'Duration_', Name: 'Duration', Align: '' },

    { Field: 'Completed_Seq', Name: 'Completed Seq', Align: '' },
  ];




  public OP_80_report_Export = [
    { Field: 'Job_Order_No', Name: 'Job Order No', Align: '' },
    { Field: 'Job_Serial_No', Name: 'Job Serial No', Align: '' },
    { Field: 'Model_No', Name: 'Model No', Align: '' },
    { Field: 'Job_Order_Serail_No', Name: 'Job Order Serail_No', Align: '' },

    { Field: 'GB_Serial_No', Name: 'GB Serial No', Align: '' },
    { Field: 'Pallet_No', Name: 'Pallet_No', Align: '' },
    { Field: 'Model_Desc', Name: 'Model Desc', Align: '' },
    { Field: 'Operator_Code', Name: ' Operator Code', Align: '' },



    { Field: 'Operator_Name', Name: 'Operator Name', Align: '' },

    { Field: 'Start_Date', Name: 'Start_Date', Align: '' },
    { Field: 'End_Date', Name: 'End_Date', Align: '' },
    { Field: 'Final_Result', Name: 'Final Result', Align: '' },
    { Field: 'Duration_', Name: 'Duration', Align: '' },


    { Field: 'Leak_test_count', Name: 'Leak test count', Align: '' },

    { Field: 'Leak_test_value', Name: 'Leak test value', Align: '' },
    { Field: 'Wash_Filling_Oil_Qty', Name: 'Wash Filling Oil_Qty', Align: '' },

    { Field: 'CW_IP_RPM', Name: 'CW_IP_RPM', Align: '' },
    { Field: 'CW_OP_RPM', Name: 'CW OP RPM', Align: '' },

    { Field: 'CW_Ratio', Name: 'CW Ratio', Align: '' },
    { Field: 'CW_Vibration', Name: 'CW Vibration', Align: '' },

    { Field: 'CCW_IP_RPM', Name: 'CCW IP RPM', Align: '' },

    { Field: 'CCW_OP_RPM', Name: 'CCW_OP RPM', Align: '' },
    { Field: 'CCW_Ratio', Name: 'CCW_Ratio', Align: '' },
    { Field: 'CCW_Vibration', Name: 'CCW_Vibration', Align: '' },

    { Field: 'Drain_QTY', Name: 'Drain QTY', Align: '' },

    { Field: 'Oil_Filling_QTY', Name: 'Oil Filling QTY', Align: '' },
    { Field: 'Hyd_Motor_Flow', Name: 'Hyd Motor Flow', Align: '' },
    { Field: 'Hyd_Motor_Pressure', Name: 'Hyd Motor Pressure', Align: '' },
    { Field: 'Cleanliness_Factor', Name: 'Cleanliness_Factor', Align: '' },
    { Field: 'Torque_Wrinch_Count', Name: 'Torque_Wrinch_Count', Align: '' },
    { Field: 'Cleanliness_Factor_HO', Name: 'Cleanliness Factor HO', Align: '' },
    { Field: 'Shift', Name: 'Shift', Align: '' },
  ];


  public OP_80B_report_Export = [
    { Field: 'Job_Order_No', Name: 'Job Order No', Align: '' },
    { Field: 'Job_Serial_No', Name: 'Job Serial No', Align: '' },
    { Field: 'Model_No', Name: 'Model No', Align: '' },
    { Field: 'Job_Order_Serail_No', Name: 'Job Order Serail_No', Align: '' },

    { Field: 'GB_Serial_No', Name: 'GB Serial No', Align: '' },
    { Field: 'Pallet_No', Name: 'Pallet_No', Align: '' },
    { Field: 'Model_Desc', Name: 'Model Desc', Align: '' },
    { Field: 'Operator_Code', Name: ' Operator Code', Align: '' },



    { Field: 'Operator_Name', Name: 'Operator Name', Align: '' },

    { Field: 'Start_Date', Name: 'Start_Date', Align: '' },
    { Field: 'End_Date', Name: 'End_Date', Align: '' },
    { Field: 'Final_Result', Name: 'Final Result', Align: '' },
    { Field: 'Duration_', Name: 'Duration', Align: '' },


    { Field: 'Leak_test_count', Name: 'Leak test count', Align: '' },

    { Field: 'Leak_test_value', Name: 'Leak test value', Align: '' },
    { Field: 'Wash_Filling_Oil_Qty', Name: 'Wash Filling Oil_Qty', Align: '' },

    { Field: 'CW_IP_RPM', Name: 'CW_IP_RPM', Align: '' },
    { Field: 'CW_OP_RPM', Name: 'CW OP RPM', Align: '' },

    { Field: 'CW_Ratio', Name: 'CW Ratio', Align: '' },
    { Field: 'CW_Vibration', Name: 'CW Vibration', Align: '' },

    { Field: 'CCW_IP_RPM', Name: 'CCW IP RPM', Align: '' },

    { Field: 'CCW_OP_RPM', Name: 'CCW_OP RPM', Align: '' },
    { Field: 'CCW_Ratio', Name: 'CCW_Ratio', Align: '' },
    { Field: 'CCW_Vibration', Name: 'CCW_Vibration', Align: '' },

    { Field: 'Drain_QTY', Name: 'Drain QTY', Align: '' },

    { Field: 'Oil_Filling_QTY', Name: 'Oil Filling QTY', Align: '' },
    { Field: 'Hyd_Motor_Flow', Name: 'Hyd Motor Flow', Align: '' },
    { Field: 'Hyd_Motor_Pressure', Name: 'Hyd Motor Pressure', Align: '' },
    { Field: 'Cleanliness_Factor', Name: 'Cleanliness_Factor', Align: '' },
    { Field: 'Torque_Wrinch_Count', Name: 'Torque_Wrinch_Count', Align: '' },
    { Field: 'Cleanliness_Factor_HO', Name: 'Cleanliness Factor HO', Align: '' },
    { Field: 'Shift', Name: 'Shift', Align: '' },
  ];
  public Pending_Invoice_Export = [
    { Field: 'Invoice_No', Name: 'Invoice No', Align: '' },
    { Field: 'Invoice_Date', Name: 'Invoice Date', Align: '' },
    { Field: 'Item_Name', Name: 'Item Name', Align: '' },
    { Field: 'Description', Name: 'Description', Align: '' },
    { Field: 'Billed_Qty', Name: 'Billed_Qty', Align: 'right' },
  ];

  public SFG_Tracking_Export = [
    { Field: 'Pack_Date', Name: 'Date', Align: '' },
    { Field: 'Packing_No', Name: 'Box No', Align: '' },
    { Field: 'Part_No', Name: 'Part No', Align: '' },
    { Field: 'DO_No', Name: 'DO No', Align: '' },
    { Field: 'Packed_Qty', Name: 'Packed Qty', Align: 'right' },
    { Field: 'Dis_Status', Name: 'Dis Status', Align: 'right' },
    { Field: 'DC_No', Name: 'DC No', Align: 'right' },
    { Field: 'DC_OK_ID', Name: 'DC Track ID', Align: 'right' },
  ];



  public Loss_Export = [

    { Field: 'Date', Name: 'Date', Align: '' },
    { Field: 'Line_No', Name: 'Line No', Align: '' },
    { Field: 'Model_No', Name: 'Model No', Align: '' },
    { Field: 'Loss_Description', Name: 'Loss Description', Align: '' },
    { Field: 'Loss_Qty', Name: 'Loss Qty', Align: '' },
    { Field: 'Incharge', Name: 'Incharge', Align: '' },
    { Field: 'Loss_Type', Name: 'Loss Type', Align: '' },
    { Field: 'Loss_Minute', Name: 'Loss Minute', Align: 'right' },
    { Field: 'Loss_Categroy', Name: 'Loss Categroy', Align: '' },
    { Field: 'Shift', Name: 'Shift', Align: '' },

  ];
  public WTF_Dispatched_Export = [
    { Field: 'Pack_Date', Name: 'Date', Align: '' },
    { Field: 'Packing_No', Name: 'Box No', Align: '' },
    { Field: 'Part_No', Name: 'Part No', Align: '' },
    { Field: 'DO_No', Name: 'DO No', Align: '' },
    { Field: 'Packed_Qty', Name: 'Packed Qty', Align: 'right' },
    { Field: 'Dis_Status', Name: 'Dis Status', Align: 'right' },
    { Field: 'DC_No', Name: 'DC No', Align: 'right' },
    { Field: 'DC_OK_ID', Name: 'DC Track ID', Align: 'right' },
  ];

  public WTF_Printing_Export = [
    { Field: 'Delivery_No', Name: 'Delivery No', Align: '' },
    { Field: 'Line_Items', Name: 'Line', Align: '' },
    { Field: 'Material_Code', Name: 'Material Code', Align: '' },
    { Field: 'Plant', Name: 'Desc', Align: '' },
    { Field: 'Qty', Name: 'Qty', Align: 'right' },


  ];

  public Head_Assignment_Export = [
    { Field: 'Department', Name: 'Department', Align: '' },
    { Field: 'HOD1_Name', Name: 'HOD1 Name', Align: '' },
    { Field: 'HOD2_Name', Name: 'HOD2 Name', Align: '' }

  ];
  public Product_Master_Export = [
    { Field: 'Display_order', Name: 'order', Align: '' },
    { Field: 'Category', Name: 'Category', Align: '' },
    { Field: 'Item_Name', Name: 'Item Name', Align: '' },
    { Field: 'Description', Name: 'Tamil Name', Align: '' },
    { Field: 'Bag_Qty', Name: 'Bag Qty', Align: '' },
    { Field: 'Rate', Name: 'Rate', Align: '' }
  ];


  public User_Master_Export = [
    { Field: 'Code', Name: 'Code', Align: '' },
    { Field: 'Name', Name: 'Name', Align: '' },
    { Field: 'User_ID', Name: 'User_ID', Align: '' },
    { Field: 'Password', Name: 'Password', Align: '' },
    { Field: 'Rights', Name: 'Rights', Align: '' },


  ];

  public RO_Defect_Export = [
    { Field: 'JOB_Order_Serial_No', Name: 'JOB Order Serial No', Align: '' },
    { Field: 'JobOrderNo', Name: 'Job Order No', Align: '' },
    { Field: 'ModelNo', Name: 'Model No', Align: '' },
    { Field: 'Part_Code', Name: 'Part Code', Align: '' },
    { Field: 'Description', Name: 'Description', Align: '' },
    { Field: 'Operator_Code', Name: 'Operator Code', Align: 'right' },
    { Field: 'Defective_Part_Code', Name: 'Defective Part Code', Align: 'right' },
    { Field: 'Other_FTQ_Defects', Name: 'FTQ Defects', Align: '' },
    { Field: 'Defective_Part_Serial_No', Name: 'Defective Part Serial No', Align: '' },
    { Field: 'Defective_Part_Qty', Name: 'Defective Part Qty', Align: 'right' },
    { Field: 'Defect_Category', Name: 'Defect Category', Align: 'right' },
    { Field: 'Operator_Remarks', Name: 'Remarks', Align: 'right' },

  ];
  public Defect_Entry_Export = [
    { Field: 'Service_Category', Name: 'Service', Align: '' },

    { Field: 'Category_', Name: 'Category', Align: '' },

    { Field: 'Test_Name', Name: 'Test Name', Align: '' },
    { Field: 'Unit', Name: 'Unit', Align: '' },
    { Field: 'Input_type', Name: 'Input type', Align: '' },
    { Field: 'Default_Result', Name: 'Default Result', Align: '' },
    { Field: 'Rate', Name: 'Rate', Align: '' }

  ];
  public Visitor_check_Export = [
    { Field: 'Defect_No', Name: 'Defect No', Align: '' },
    { Field: 'Defect_Date', Name: 'Defect Date', Align: '' },
    { Field: 'Part_Code', Name: 'Part Code', Align: '' },
    { Field: 'Part_Name', Name: 'Part Name', Align: '' },
    { Field: 'Model', Name: 'Model', Align: '' },
    { Field: 'Qty', Name: 'Qty', Align: '' },
    { Field: 'Supplier_Name', Name: 'Supplier_Name', Align: '' },
    { Field: 'Complaint_No', Name: 'Complaint No', Align: '' },
    { Field: 'Problem_Description', Name: 'Problem_Description', Align: '' },
    { Field: 'Containment_Status', Name: 'Status', Align: '' },
    { Field: 'Notification_Number', Name: 'Notification_Number', Align: '' },
    { Field: 'Remarks', Name: 'Remarks', Align: '' },
    { Field: 'Responsibility', Name: 'Responsibility', Align: '' },

  ];

  public Responsibilitywise_Export = [
    { Field: 'Responsibility', Name: 'Responsibility', Align: '' },
    { Field: 'Count', Name: 'Count', Align: '' },
  ];

  public Problemwise_Export = [
    { Field: 'Problem', Name: 'Problem', Align: '' },
    { Field: 'Count', Name: 'Count', Align: '' },
  ];
  public Defect_Entry_Report_Export = [
    { Field: 'Defect_No', Name: 'Defect No', Align: '' },
    { Field: 'Defect_Date', Name: 'Defect Date', Align: '' },
    { Field: 'Part_Code', Name: 'Part Code', Align: '' },
    { Field: 'Part_Name', Name: 'Part Name', Align: '' },
    { Field: 'Model', Name: 'Model', Align: '' },
    { Field: 'Qty', Name: 'Qty', Align: '' },
    { Field: 'Supplier_Name', Name: 'Supplier_Name', Align: '' },
    { Field: 'Complaint_No', Name: 'Complaint No', Align: '' },
    { Field: 'Problem_Description', Name: 'Problem_Description', Align: '' },
    { Field: 'Containment_Status', Name: 'Containment_Status', Align: '' },
    { Field: 'Notification_Number', Name: 'Notification_Number', Align: '' },
    { Field: 'Remarks', Name: 'Remarks', Align: '' },
    { Field: 'Responsibility', Name: 'Responsibility', Align: '' },

  ];


  public Problemwise_Report_Export = [
    { Field: 'Defect_No', Name: 'Defect No', Align: '' },
    { Field: 'Problem', Name: 'Problem', Align: '' },
    { Field: 'Defect_Date', Name: 'Defect Date', Align: '' },
    { Field: 'Part_Code', Name: 'Part Code', Align: '' },
    { Field: 'Part_Name', Name: 'Part Name', Align: '' },
    { Field: 'Model', Name: 'Model', Align: '' },
    { Field: 'Qty', Name: 'Qty', Align: '' },
    { Field: 'Supplier_Name', Name: 'Supplier Name', Align: '' },

    { Field: 'Containment_Status', Name: 'Containment Status', Align: '' },



  ];

  public Responsibility_Report_Export = [
    { Field: 'Defect_No', Name: 'Defect No', Align: '' },
    { Field: 'Problem', Name: 'Problem', Align: '' },
    { Field: 'Defect_Date', Name: 'Defect Date', Align: '' },
    { Field: 'Part_Code', Name: 'Part Code', Align: '' },
    { Field: 'Part_Name', Name: 'Part Name', Align: '' },
    { Field: 'Model', Name: 'Model', Align: '' },
    { Field: 'Qty', Name: 'Qty', Align: '' },
    { Field: 'Supplier_Name', Name: 'Supplier Name', Align: '' },
    { Field: 'Responsibility', Name: 'Responsibility', Align: '' },

    { Field: 'Containment_Status', Name: 'Containment_Status', Align: '' },

  ];
  public Production_Plan_Export = [
    { Field: 'Plan_Date', Name: 'Plan Date', Align: '' },
    { Field: 'Plan_Shift', Name: 'Shift', Align: '' },
    { Field: 'Machine_ID', Name: 'Machine ID', Align: '' },
    { Field: 'ModelNo', Name: ' Model No', Align: '' },
    { Field: 'Part_No', Name: 'Part No', Align: '' },
    { Field: 'Plan_Qty', Name: 'Qty', Align: '' },

  ];



  public Ledger_Master_Exel_Export = [
    { Field: 'Ledger_Name', Name: 'Ledger Name', Align: '' },
    { Field: 'Short_Name', Name: 'Short Name', Align: '' },
    { Field: 'Phone_No', Name: 'Phone No', Align: '' },
    { Field: 'Area', Name: 'Area', Align: '' },
    { Field: 'Street', Name: 'Street', Align: '' },
    { Field: 'Address', Name: 'Address', Align: '' },
    { Field: 'Amount', Name: 'Amount', Align: 'right' },
    { Field: 'VC_Number', Name: 'VC Number', Align: '' },
    { Field: 'Join_Date', Name: 'Join Date', Align: '' },
    { Field: 'Status', Name: 'Status', Align: '' }

  ];










  public Quotation_Export = [];
  public Purchase_Export = [];
  public Adjustment_Export = [];

  public Sales_Export = [];
  public Delivery_Export = [];



  public Sales_Return_Export = [];

  public Purchase_Order_Export = [];
  public Member_Registration_Export = [];
  public Proforma_Export = [];
  public Ledger_Master_Export = [];

  public Area_Master_Export = [];
  public MOnthWIse_Export = ['Machine_Name'];

  public Line_Wise_Production_GF = ['Pro_Date', 'Line_No', 'Model_No', 'Shift', 'Qty', 'Rej_Qty', 'Rework_Qty', 'Part_No', 'Start_Time', 'End_Time', 'Tea_Min', 'Lunch_Min', 'Work_Hours', 'Actual_Hours'];
  public Production_Export = [];
  public Employee_Details_Export = [
    { Field: 'Code', Name: 'Code', Align: 'center' },
    { Field: 'Name', Name: 'Name', Align: 'center' },
    { Field: 'Gender', Name: 'Gender', Align: 'center' },
    { Field: 'Department', Name: 'Department', Align: 'center' },
    { Field: 'Designation', Name: 'Designation', Align: 'center' },
    { Field: 'Email_ID', Name: 'Email ID', Align: 'center' },
    { Field: 'Contact_No', Name: 'Contact No', Align: 'right' },


  ];
  public Holiday_Details_Export = [];
  public img_visible: boolean = false;


  public Order_enty_type = "Type1";
  public page_Name = "Order_Entry";

  public from_customer: boolean = false;
  public from_customer_Code = "";

  public DF_Paymode = "244";
  public DF_Checkin_by = "40";
  public DF_Checkin_Type = "35";
  public DF_Stay_purpose = "31";

  public C_Sub_Total = 0;
  public C_Delivery_Charges = 0;
  public C_Taxable = 0;
  public C_IGST = 0;
  public C_SGST = 0;
  public C_CGST = 0;
  public C_Tax = 0;
  public C_Total_Payable = 0;
  public C_Savings = 0;

  public Item_Category = [];
  public Selected_item_Category = "";

  public Date;
  public Date1;
  public From_Date;
  public To_Date;

  public User_Type = "Admin";
  public Document_Type = "Front_Banner";
  public Phone_Pattern = "^((\\+91-?)|0)?[0-9]{10}$";
  public Receipt_Print = "false";

  public Side_Menu: boolean = false;
  public Today_Date = "";
  public S_From = "";
  public S_To = "";

  public S_From_T = "";
  public S_To_T = "";
  public Part_No = "All";
  public DO_No = "";
  public Dis_Status = "";
  public Status_ = "All";
  public S_Bill_Type = "All";
  public S_Thari_Status = "All";

  public Category = "All";

  public S_Pay_Mode = "0";
  public S_Bill_Mode = "All";
  public S_Area = "All"
  public S_Sales_Order_by = "Bill_No";
  public S_Stock = "All"
  public S_Sales_Person = "All"


  public Y_Date = "";
  public data: any = {};
  public Order_Status = "Pending";
  public Search_User = "All";
  public Approval_Status = "Pending";
  public Laptop_Approval = "Pending";
  public Mobile_Approval = "Pending";
  public Report_Status = "Review Pending";

  public Customer_Area = "All";
  public item_name_disp = "English";

  public T_Date = "";
  public T_Time = "";

  public T_Date_Time = "";
  public T_Date_Time_ = "";

  public T_Date_TimeD = "";

  public Pay_Date = "";


  public back() {
    this._location.back();
    const isShowTopNav = this.document.getElementById('navbar');
    isShowTopNav.classList.remove('topNavHide');
  }


  public datefromat(data) {
    return this.formatDate(data, "yyyy-MM-dd");
  }

  public datetimefromat(data) {
    return this.formatDate(data, "yyyy-MM-ddTHH:mm");
  }



  public date_display(data) {
    return this.formatDate(data, "dd-MMM-yyyy");
  }
  public S_Model_No = "";
  public Rights_Name = "";
  public Rights_ID = "";
  public Emp_ID = "";
  public Emp_Name = "";
  public Login_User = "";
  public Emp_Dept = "";
  public Emp_Approver = "";
  public Emp_Approver_Name = "";


  getData() {
    return JSON.parse(localStorage.getItem('User_Data'));
  }


  Cash_ID = "";
  Cheque_ID = "";
  Card_ID = "";
  Prow = [];
  Pay_Mode_Rows = [];

  get_pay_mode_ID() {

    try {
      this.Prow = this.Reference_Rows.filter(e => e.Ref_ID == "Pay_Mode");
      this.Pay_Mode_Rows = this.Reference_Rows.filter(e => e.Ref_ID == "Pay_Mode");
      this.Cash_ID = this.Prow.filter(e => e.RGV_vDesciption.toLowerCase() == "cash")[0].RGV_iID;
      this.Cheque_ID = this.Prow.filter(e => e.RGV_vDesciption.toLowerCase() == "cheque")[0]["RGV_iID"];
      this.Card_ID = this.Prow.filter(e => e.RGV_vDesciption.toLowerCase() == "card")[0]["RGV_iID"];
      this.Pay_Mode = this.Cash_ID;
    } catch { }
  }


  public pay_Mode_reset() {
    this.Pay_Mode = this.Cash_ID;
    this.Receiving_Bank = "0";
    this.Cheque_No = "";
    this.Cheque_Date = this.Today_Date;
    this.Card_Charge = "";
    this.Remarks = "";

  }


  public isEdit: boolean = false;
  public isMail: boolean = false;
  public Pay_Mode = "";
  public Bill_Mode = "Cash";
  public Receiving_Bank = "0";
  public Cheque_No = "";
  public Cheque_Date = this.Today_Date;
  public Card_Charge = "";
  public Remarks = "";



  public Bill_No = "";
  public Bill_Date = "";
  public Due_Date = "";
  public Place_of_Supply = "";
  public Sales_Person = "";
  public header_hide: boolean = false;

  public Lab_Home_Page = "";

  public Pay_Mode_ID = "";
  public User_Master_Rows = [];
  get_User_Master() {
    this.getc("Api/Common/get_User_Master").subscribe((res: any) => {
      this.User_Master_Rows = JSON.parse(res).record;
    });
  }

  public Line_wise_Production_details = [
    { Menu: 'Line Wise Production ', Link: 'report/linewise-production-details' },
    { Menu: 'Day Wise Production ', Link: 'report/daywise-production-details' },
    { Menu: 'Month Wise Production ', Link: 'report/monthwise-production-details' }

  ];

  public Partol_Inspection = [

    { Menu: 'Monthwise Inspection', Link: 'report/month-wise-patrol' },
    { Menu: 'Linewise Inspection', Link: 'report/line-wise-patrol' },


  ];
  public dayWiseHourlyProductionDetails = [
    { Menu: 'Production Monitor ', Link: 'dashboard/production-monitor', Icon: 'bx bx-time-five' },
    { Menu: 'Cycle Time Analysis', Link: 'dashboard/cycle-time-analysis', Icon: 'bx bx-recycle' },
    { Menu: 'Loss Analysis', Link: 'dashboard/loss-analysis-dashboard', Icon: 'bx bxs-analyse' },
    { Menu: 'Production Summary', Link: 'dashboard/production-summary', Icon: 'bx bx-desktop' },
    { Menu: 'Daywise OEE', Link: 'dashboard/daywise-oee', Icon: 'bx bx-bar-chart-square' },
  ];

  public PlantOEEDetails = [
    { Menu: 'Daily Review', Link: 'dashboard/daily-review', Icon: 'bx bx-time-five' },
    { Menu: 'Plant OEE', Link: 'dashboard/plant-oee', Icon: 'bx bx-sitemap' },
    { Menu: 'Hourly Production', Link: 'dashboard/hourly-production', Icon: 'bx bxs-analyse' },
    { Menu: 'DRM KPI', Link: 'dashboard/drm-kpi', Icon: 'bx bxs-dashboard' },

  ]
  public MachineStatusDetails = [
    { Menu: 'Machine Status', Link: 'dashboard/machine-status', Icon: 'bx bx-tachometer' },
    { Menu: 'Machine KPI', Link: 'dashboard/machine-kpi', Icon: 'bx bx-bar-chart-square' },
    { Menu: 'Daywise Breakdown', Link: 'dashboard/daywise-breakdown', Icon: 'bx bx-calendar' },
  ]

  public Dashboard_Menu = [

    { Menu: 'Production Monitor', Link: 'dashboard/production-monitor', Icon: 'bx bx-time-five' },
    { Menu: 'Production Monitor', Link: 'dashboard/cycle-time-analysis', Icon: 'bx bxs-analyse' },
    { Menu: 'Loss Analysis', Link: 'dashboard/loss-analysis-dashboard', Icon: 'bx bx-desktop' },
    { Menu: 'Production Summary', Link: 'dashboard/production-summary', Icon: 'bx bx-desktop' }

  ];



  public W_height = 0;
  public W_width = 0;

  lenth: number = 0;
  public order_Rows = [];
  public Orders_sort_by = "order_Date"



 


  public Item_Image_List_count = 0;
  public Item_Image_List = [];
  get_Item_Image(ID) {

    this.Item_Image_List = [];
    this.Item_Image_List_count = 0;
    this.get("Api/Master/get_Item_Image_List?ID=" + ID).subscribe((res: any) => {
      this.Item_Image_List = JSON.parse(res).record;

      try {
        this.Item_Image_List_count = this.Item_Image_List.length;

      } catch { }

    });

  }


  public Machine_No = "";

  public Machine_Details_Rows = [];
  get_Machine_Details() {
    this.Machine_Details_Rows=[];
    this.get("Api/transaction/get_Machine_Details?").subscribe((res: any) => {
    this.Machine_Details_Rows = JSON.parse(res).record;



    });

  }
  
  get_Operator_Details() {
    this.Operator_Row=[];
    this.get("Api/transaction/get_Operator_Name?").subscribe((res: any) => {
    this.Operator_Row = JSON.parse(res).record;



    });

  }

  


  Operator_Row_All=[];
  get_Operator_All() {
    this.Operator_Row_All=[];
    this.get("Api/transaction/get_Operator?").subscribe((res: any) => {
    this.Operator_Row_All = JSON.parse(res).record;



    });

  }

  get_Incharge_Details() {
    this.Inspector_Row=[];
    this.get("Api/transaction/get_Inspector?").subscribe((res: any) => {
    this.Inspector_Row = JSON.parse(res).record;



    });

  }
  public Rev_No="";
  public Format_No="";

  public Rev_Format_Rows;
  get_Rev_Format_Rows(data) {
  
    this.Rev_Format_Rows;
    this.get("Api/Inspection/get_Rev_Format?Ins_Type="+data).subscribe((res: any) => {
    this.Rev_Format_Rows = JSON.parse(res).record[0];
    this.Rev_No=this.Rev_Format_Rows.Rev_No;
    this.Format_No=this.Rev_Format_Rows.Format_No;
  
    });
  
  }





  S_State = "All";







  public Deleted_Order_GF = ['Table_', 'Item_Name', 'Created_by', 'Created_Date'];
  public Variable_Settings_GF = ['ID', 'S_Variable', 'S_Value', 'S_Default'];


  public Delete_Order_Details_Row = [];
  public Delete_Order_Details() {
    this.isload = true;
    this.Delete_Order_Details_Row = [];
    this.get("Api/Invoice/get_Delete_Order_Detail?From=" + this.S_From + "&To=" + this.S_To + "&User=" + this.Search_User + "&order_by=Created_Date").subscribe((res: any) => {
      this.isload = false;
      this.Delete_Order_Details_Row = JSON.parse(res).record;
    });

  }
  public Cusomer_Details_Rowdata = "";

  public Cusomer_Details_Row = [];
  public Customer_Details() {
    this.isload = true;
    this.Cusomer_Details_Row = [];
    this.get("Api/Invoice/get_Customer_Sales?Uni_Code=" + this.Cusomer_Details_Rowdata).subscribe((res: any) => {
      this.Cusomer_Details_Row = JSON.parse(res).record;
      this.isload = false;

    });

  }






  public Dashboard_Row = [];
  get_Dashboard() {
    this.Dashboard_Row = [];
    this.loading = true;

    this.get("Api/Master/get_dashboard?").subscribe((res: any) => {
      this.Dashboard_Row = JSON.parse(res).record;
      this.loading = false;
    });
  }
  master_exp: boolean = false;
  public Mail_Type = "All";

  public Department_Email_Row = [];
  get_Department_Email() {

    this.Department_Email_Row = [];
    this.get("Api/Master/get_Department_Email?Mail_Type=" + this.Mail_Type).subscribe((res: any) => {
      this.Department_Email_Row = JSON.parse(res).record;

    });

  }

  public Machine_capacity_Row = [];
  get_Machine_Capacity() {
    this.isload = true;
    this.Machine_capacity_Row = [];
    this.getc("Api/Master/get_Machine_Capacity").subscribe((res: any) => {
      this.Machine_capacity_Row = JSON.parse(res).record;
      this.isload = false;
    });

  }



  public Department_Email_GF = [];


  public Productwise_Row = [];

  public Customerwise_Row = [];
  



  public DB_Damage_Total = 0;
  public Damage_Row = [];
  get_Damage_Details() {
    this.isload = true;
    this.DB_Damage_Total = 0;
    this.get("Api/Invoice/get_Damage_Detail?From=" + this.S_From + "&To=" + this.S_To + "&User=" + this.Search_User + "&Bill_Type=" + this.S_Bill_Type + "&order_by=Damage_Date,Damage_No").subscribe((res: any) => {
      this.Damage_Row = JSON.parse(res).record;
      this.isload = false;

      try {
        this.DB_Damage_Total = this.Damage_Row.reduce((sum, current) => sum + parseFloat(current.Net_Amt), 0);
      } catch { }

    });

  }


  S_Data = "";
public Machine_Type="";


  public get_Inspection_Type_Rows = [];
  get_Inspection_Type() {
    this.get_Inspection_Type_Rows=[];

    this.getc("Api/master/get_Ins_Type").subscribe((res: any) => {
      this.get_Inspection_Type_Rows = JSON.parse(res).record;
    });
  }

  public Print_Total = 0;
  public Print_Row = [];
  get_Print_Details() {
    this.isload = true;
    this.Print_Total = 0;
    this.get("Api/Invoice/get_Print_Barcode?From=" + this.S_From + "&To=" + this.S_To + "&Bill_Mode=" + this.S_Bill_Mode).subscribe((res: any) => {
      this.Print_Row = JSON.parse(res).record;
      this.isload = false;

      try {
        this.Print_Total = this.Print_Row.reduce((sum, current) => sum + parseFloat(current.Net_Amt), 0);
      } catch { }

    });

  }




 





  Machine_Row = [];
  get_Machine() {
    this.getc("Api/master/get_Machine_Name_All").subscribe((res: any) => {
      this.Machine_Row = JSON.parse(res).record;
    });
  }




  public Ledger_Group = [];
  get_Ledger_Group() {
    this.isload = true;
    this.getc("Api/Master/get_Ledger_Group").subscribe((res: any) => {
      this.Ledger_Group = JSON.parse(res).record;
      this.isload = false;
      console.log()
    });

  }

  public S_Group = 0;
  public S_Category = 0;
  public S_Brand = 0;

  public Item_Group = [];
  get_Item_Group() {
    this.isload = true;
    this.getc("Api/Master/get_Item_Group").subscribe((res: any) => {
      this.Item_Group = JSON.parse(res).record;
      this.isload = false;
    });

  }

 





  public S_Item_ID = "";
  public S_Item_Name = "";





  L = [];
  get_Array(data) {
    this.L = data.split(",");

    return this.L;
  }

  Date_wise_sales_Row = [];
  Item_wise_sales_Row = [];
  Areawise_Sales_Sum_Row = [];
  userwise_Sales_Sum_Row = [];
  Paymodewise_Sales_Sum_Row = [];
  Billwise_Sales_Sum_Row = [];
  Customerwise_sales_Row = [];



  public S_customer = "0";
  public S_Sales = "All";
  public S_Visitor_Type = "All";
  public S_Department = "All";
  public Department = "";

  public Outstand_Amt = 0;
  public Outstanding_Rows = [];
  public selected_Out_customer: any = {}
  public selected_Out_supplier: any = {}


  ago(value: any, args?: any): any {


    if (value) {
      const seconds = Math.floor((+new Date() - +new Date(value)) / 1000);
      if (seconds < 29) // less than 30 seconds ago will show as 'Just now'
        return 'Just now';
      const intervals = {
        'year': 31536000,
        'month': 2592000,
        'week': 604800,
        'day': 86400,
        'hour': 3600,
        'min': 60,
        'sec': 1
      };
      let counter;
      for (const i in intervals) {
        counter = Math.floor(seconds / intervals[i]);
        if (counter > 0)
          if (counter === 1) {
            return counter + ' ' + i + ' ago'; // singular (1 day ago)
          } else {
            return counter + ' ' + i + 's ago'; // plural (2 days ago)
          }
      }
    }
    return value;
  }
  public Checker_Approval_Row = [];
  public Checker_Approval_Row_ = [];
  public Checker_Inspection_Total = 0;
  public Inspector_Name = "All";

  get_Inspection_Approval_Details() {
    this.isload = true;
    this.Checker_Approval_Row = [];
    this.Checker_Approval_Row_ = [];

    this.get("Api/Transaction/get_Inspection_Approval?From=" + this.S_From + "&To=" + this.S_To + "&Inspector_Name=" + this.Inspector_Name + "&order=Date,Batch_No").subscribe((res: any) => {
      this.Checker_Approval_Row = JSON.parse(res).record;
      this.Checker_Approval_Row_ = JSON.parse(res).record;

      this.isload = false;

      try {
        this.Checker_Inspection_Total = this.Checker_Approval_Row_.length;
      } catch { }


    });

  }
  public Line_Approval_Row = [];
  public Line_Approval_Row_ = [];
  public Line_Inspection_Total = 0;

  get_Line_Approval_Details() {
    this.isload = true;
    this.Line_Approval_Row = [];
    this.Line_Approval_Row_ = [];

    this.get("Api/Transaction/get_Line_Approval?From=" + this.S_From + "&To=" + this.S_To + "&order=Date,Batch_No").subscribe((res: any) => {
      this.Line_Approval_Row = JSON.parse(res).record;
      this.Line_Approval_Row_ = JSON.parse(res).record;

      this.isload = false;


    });

  }
  public Approval_Incharge_count = 0;
  public Approval_Incharge_Row = [];
  get_Approval_Incharge() {
    this.isload = true;
    this.Approval_Incharge_Row = [];
    this.get("Api/Master/get_Approval_Incharge?Emp_ID=" + this.Emp_ID).subscribe((res: any) => {
      this.Approval_Incharge_Row = JSON.parse(res).record;
      this.isload = false;



    });
  }
  Click_data = "";
  public INS_Type = "All"
  public Ins_Type = "All"

  public Batch_No = ""
  public Operator = "All";

  public DB_Inspection_Total = 0;
  public Inspection_Control_Row = [];

  public Inspection_Details_Row = [];
  public Inspection_Details_Row_ = [];

  get_Inspection_Details() {
    this.isload = true;
    this.DB_Inspection_Total = 0;
    this.Inspection_Details_Row = [];

    this.get("Api/Inspection/get_Inspection_Detail?From=" + this.S_From + "&To=" + this.S_To + "&User=" + this.Search_User + "&order=Date,Batch_No" + "&INS_Type=" + this.INS_Type).subscribe((res: any) => {
      this.Inspection_Details_Row = JSON.parse(res).record;
      this.Inspection_Details_Row_ = JSON.parse(res).record;

      this.isload = false;

      try {

        this.DB_Inspection_Total = this.Inspection_Details_Row.length;
      } catch { }
    });

  }
  public Receiving_Approval_Row = [];
  public Receiving_Approval_Row_ = [];
  public Receiving_Inspection_Total = 0;

  get_Receiving_Approval_Details() {
    this.isload = true;
    this.Receiving_Approval_Row = [];
    this.Receiving_Approval_Row_ = [];

    this.get("Api/Master/get_Receiving_Approval?From=" + this.S_From + "&To=" + this.S_To + "&order=Date,Batch_No").subscribe((res: any) => {
      this.Receiving_Approval_Row = JSON.parse(res).record;
      this.Receiving_Approval_Row_ = JSON.parse(res).record;

      this.isload = false;


    });

  }


  public Loss_Categroy = "All";
  public Loss_Type = "All"
  public Loss_Analysis_Rows = [];

  public Loss_Details_Rows = [];
  Loss_Qty = 0;
  Loss_min = 0;
  Total_Loss_Details = 0;
  get_Loss_Details() {
    this.loading = true;
    this.isload = true;
    this.Loss_Details_Rows = [];
    this.Loss_Qty = 0;
    this.Loss_min = 0;
    this.Total_Loss_Details = 0;
    this.get("Api/Invoice/get_Loss_Details?From=" + this.S_From + "&To=" + this.S_To).subscribe((res: any) => {
      this.Loss_Details_Rows = JSON.parse(res).record;
      this.loading = false;
      this.isload = false;
      try {
        this.Total_Loss_Details = this.Loss_Details_Rows.length

        this.Loss_min = (this.Loss_Details_Rows.reduce((sum, current) => sum + parseFloat(current.Loss_Minute), 0)).toFixed(0);
      }
      catch { }
    });
  }


  public Machine_Moniter_Rows = [];
  public Machine_Moniter_Rows_P = []
  public Machine_Type_Row_ = [];

  public Line_Row = [];

  MC_Working = 0;
  MC_Break_down = 0;
  MC_No_Plan = 0;
  MC_Processing = 0;


  Pending_Count = 0;
  get_Machine_Moniter() {
    this.MC_Working = 0;
    this.MC_Break_down = 0;
    this.MC_No_Plan = 0;
    this.MC_Processing = 0;

    this.isload = false;
    this.Machine_Moniter_Rows = [];
    this.getc("Api/Master/get_Machine_Moniter").subscribe((res: any) => {
      this.Machine_Moniter_Rows = JSON.parse(res).record;


      for (let data of this.Machine_Moniter_Rows) {

        if (data.Color == 'Breakdown') {
          this.MC_Break_down = this.MC_Break_down + 1;
        } else if (data.Color == 'Working') {
          this.MC_Working = this.MC_Working + 1;
        }
        else if (data.Color == 'Processing') {
          this.MC_Processing = this.MC_Processing + 1;
        }
        else {
          this.MC_No_Plan = this.MC_No_Plan + 1;
        }

      }


      this.Machine_Moniter_Rows_P = JSON.parse(res).record;
      this.isload = false;
      this.Line_Row = [...new Set(this.Machine_Moniter_Rows.map(item => item.Line_No))];

      var Item = [...new Set(this.Machine_Moniter_Rows.map(item => item.Color))];
      this.Machine_Type_Row_ = [];

      for (let data of Item) {
        var count = this.Machine_Moniter_Rows.filter(e => e.Color == data).length;
        this.Machine_Type_Row_.push({ Type_: data, count: count })
      }

    });


  }

  public Process_Number_Row = [];
  get_Process_Number() {
    this.isload = true;
    this.Process_Number_Row = [];

    this.get("Api/Master/get_Process_Number?").subscribe((res: any) => {
      this.Process_Number_Row = JSON.parse(res).record;
      this.isload = false;


    });

  }

  public Process_Name_Row = [];
  get_Process_Name() {
    this.isload = true;
    this.Process_Name_Row = [];

    this.get("Api/Master/get_Process_Name?").subscribe((res: any) => {
      this.Process_Name_Row = JSON.parse(res).record;
      this.isload = false;


    });

  }
  open_template(ID, Ins_Type) {
    window.open(this.Server_URL + "/report/Checksheet_Template?ID=" + ID + "&Ins_Type=" + Ins_Type + "&Company=" + this.Company, "_blank");
  }

  public Critical_Types_Row = [];
  get_Critical_Types() {
    this.isload = true;
    this.Process_Name_Row = [];

    this.getc("Api/Master/get_Critical_Types").subscribe((res: any) => {
      this.Critical_Types_Row = JSON.parse(res).record;
      this.isload = false;


    });

  }
  public Loss_Responsibility = "All"
  public Loss_Action_Pending_rows = [];
  public get_Loss_Action_Pending() {
    this.isload = true;
    this.Loss_Action_Pending_rows = [];
    this.get("Api/invoice/get_Loss_Action_Pending?Loss_Responsibility=" + this.Loss_Responsibility).subscribe((res: any) => {

      this.Loss_Action_Pending_rows = JSON.parse(res).record;
      this.isload = false;



    });

  }












  public isorder_Load = false;






  load_themes(data) {
    var d = "default.css";
    try {
      d = localStorage.getItem('Theme');
    } catch { }

    if (d != "default.css" && d != null) {

      this.loadStyle(d);

    }
  }

  loadStyle(styleName: string) {
    const head = this.document.getElementsByTagName('head')[0];

    let themeLink = this.document.getElementById(
      'client-theme'
    ) as HTMLLinkElement;
    if (themeLink) {
      themeLink.href = styleName;
    } else {
      const style = this.document.createElement('link');
      style.id = 'client-theme';
      style.rel = 'stylesheet';
      style.href = `${styleName}`;

      head.appendChild(style);
    }
  }

  public get_Month_(data) {
    return this.datePipe.transform(data, "-MMM-yyyy");
  }
  S = []
  split_data(str) {
    this.S = str.split("=");
    return this.S;
  }


  public Sub_Category = "All";

  public sub_category_Rows = [];

  sub_category_Rows_(data) {

    this.sub_category_Rows = this.Item_Sub_Category.filter(e => e.category == data);
  }
  Item_Sub_Category = [];
  Sub_Category_() {


    this.getc("Api/Master/get_Item_Sub_Category").subscribe((res: any) => {
      this.Item_Sub_Category = JSON.parse(res).record;

      localStorage.setItem('Sub_Cate_Row', res);

    });
  }
  public Itemwise_order = [];
  public All_order_Rows = [];
  public Entry_wise_Order = [];
  public Areawise_Order = [];
  public Userwise_Order = [];
  public Cusomerwise_Order = [];
  public Daywise_Order = [];




  public Area_Row = [];

  public Itemwise_Pending_Rows = [];
  public Item_Pending_Total = 0;
  public Item_Pending_Qty = 0;
  get_items_pending() {
    this.isload = true;
    this.Item_Pending_Total = 0;
    this.get("Api/Invoice/get_itemwise_Pending?Status=" + this.Order_Status + "&From=" + this.S_From + "&To=" + this.S_To + "&User=" + this.Search_User + "&Area=" + this.Customer_Area + "&Order_by=i.Display_Order").subscribe((res: any) => {
      this.isload = false;
      this.Itemwise_Pending_Rows = JSON.parse(res).record;

      this.Item_Pending_Total = (this.Itemwise_Pending_Rows.reduce((sum, current) => sum + parseFloat(current.Amount), 0)).toFixed(2);


      this.Item_Pending_Qty = (this.Itemwise_Pending_Rows.reduce((sum, current) => sum + parseFloat(current.qty), 0)).toFixed(2);

    });
  }


  public Selected_Company: any = {};
  public Selected_Customer: any = {};
  public Current_User: any = {};

  public Order_No = "0";




  public Day_Wise_Production_Details_Rows = [];

  Day_Wise_Production_Details() {

    this.isload = true;
    this.Day_Wise_Production_Details_Rows = [];
    this.get("Api/Master/get_Day_Wise_Production_Details?From=" + this.S_From + "&To=" + this.S_To + "&Line_No=" + this.Line_No).subscribe((res: any) => {
      this.Day_Wise_Production_Details_Rows = JSON.parse(res).record;

      this.isload = false;
    });
  }

  public Month_Wise_Production_Details_Rows = [];

  Month_Wise_Production_Details() {

    this.isload = true;
    this.Month_Wise_Production_Details_Rows = [];
    this.get("Api/Master/get_Month_Wise_Production_Details?From=" + this.S_From + "&To=" + this.S_To + "&Line_No=" + this.Line_No).subscribe((res: any) => {
      this.Month_Wise_Production_Details_Rows = JSON.parse(res).record;
      this.isload = false;
    });
  }
  get_Category() {

    this.getc("Api/Master/get_Item_Category").subscribe((res: any) => {
      this.Item_Category = JSON.parse(res).record;
      console.log(this.Item_Category);

    });
  }

  public Document_Upload_Rows = [];
  get_Douments() {
    this.getc("Api/Master/get_Document_Upload").subscribe((res: any) => {
      this.Document_Upload_Rows = JSON.parse(res).record;
    });
  }






  public customerwise_Pending_Rows = [];
  get_customerwise_pending() {
    this.getc("Api/Invoice/get_customerwise_Pending").subscribe((res: any) => {
      this.customerwise_Pending_Rows = JSON.parse(res).record;
    });

  }


  public Field_Setting = [];

  public Field_Setting_Table_Row = [];
  get_Field_Setting_Table() {
    this.getc("Api/Setting/get_Field_Setting_Table").subscribe((res: any) => {
      this.Field_Setting_Table_Row = JSON.parse(res).record;

    });
  }
  public Bill_Format_Row = [];
  get_Bill_Format() {
    this.getc("Api/Setting/get_Bill_Format").subscribe((res: any) => {
      this.Bill_Format_Row = JSON.parse(res).record;

    });

  }

  F_Row: any[] = [];
  get_fields_of(Table: string) {

    this.F_Row = this.Field_Setting.filter(e => String(e.Table_Name).toLowerCase() == String(Table + "" + this.Company).toLowerCase()).filter(e => e.Visible == "True");
    return this.F_Row.sort((a, b) => Number(a["Order_No"]) - Number((b["Order_No"])));

  }

  get_grid_fields_of(Table: string) {

    this.F_Row = this.Field_Setting.filter(e => String(e.Table_Name).toLowerCase() == String(Table + "" + this.Company).toLowerCase()).filter(e => e.GVisible == "True");
    return this.F_Row.sort((a, b) => Number(a["GOrder"]) - Number((b["GOrder"])));

  }

  get_pos_field(Table: string, pos: string) {

    this.F_Row = this.Field_Setting.filter(e => String(e.Table_Name).toLowerCase() == String(Table + "" + this.Company).toLowerCase()).filter(e => e.Visible == "True");
    this.F_Row = this.F_Row.filter(e => String(e.Posision).toLowerCase() == String(pos).toLowerCase());
    return this.F_Row.sort((a, b) => Number(a["Order_No"]) - Number((b["Order_No"])));

  }





  public get_datas() {

    //this.get_Ledger_Master();


  }



  public Menus_Rows: any = {};

  public P_Menu_Rows = [];
  public Menu_Rows = [];
  public Label_Menu_Rows = [];
  get_Role_Rights(Role) {
    this.get("Api/Setting/get_Menu_for_user?Rights=" + Role).subscribe((res: any) => {
      this.applyRoleRights(res);
    });
  }

  m_data: any = {};
  get_sub_Menu(data) {

    this.Menu_Rows = this.P_Menu_Rows.filter(e => e.Main_Module == data);


    this.Side_Menu = true;
    var Parent = [...new Set(this.Menu_Rows.map(item => item.Parent_ID))];
    this.Label_Menu_Rows = [];
    for (let data of Parent) {
      if (data != "0") {

        this.m_data = this.Menu_Master_Rows.filter(e => e.ID == data)[0];
        this.Label_Menu_Rows.push({ 'ID': data, 'Display_Name': this.m_data.Display_Name, 'Order_No': this.m_data.Order_No, 'Icon': this.m_data.Icon })
      }
    }

  }


  page = "";
  get_Field_Setting() {
    this.getc("Api/Setting/get_Field_Setting").subscribe((res: any) => {

      if (res == "No_Licence") {
        this.router.navigate(['/invalid-licence']);
      }
      else {
        this.Field_Setting = JSON.parse(res).record;
        this.get_Setting_Setting();
      }
    });


  }


  get_variable_Value(data) {


    if (data == "Stockbase_Sales") {
      try {
        if (this.SM_Row.filter(e => e.S_Variable == data).length > 0) {
          if ((this.SM_Row.filter(e => e.S_Variable == data)[0].S_Value) == "true") {
            this.Stockbase_Sales = true;
          }

        }

      } catch { }

    }
    else if (data == "Check_Stock") {
      try {
        if (this.SM_Row.filter(e => e.S_Variable == data).length > 0) {
          if ((this.SM_Row.filter(e => e.S_Variable == data)[0].S_Value) == "true") {
            this.Check_Stock = true;
          }

        }

      } catch { }

    }

    else if (data == "Logo_Name") {
      try {
        if (this.SM_Row.filter(e => e.S_Variable == data).length > 0) {
          this.Logo_Name = this.SM_Row.filter(e => e.S_Variable == data)[0].S_Value;
        }

      } catch { }

    }
    if (data == "Sales_Entry_Page") {
      try {
        if (this.SM_Row.filter(e => e.S_Variable == data).length > 0) {
          this.Sales_Entry_Page = this.SM_Row.filter(e => e.S_Variable == data)[0].S_Value;
        }

      } catch { }

    }
    else if (data == "Balance_SMS") {
      try {
        if (this.SM_Row.filter(e => e.S_Variable == data).length > 0) {
          this.Balance_SMS = this.SM_Row.filter(e => e.S_Variable == data)[0].S_Value;
        }

      } catch { }

    }
    else if (data == "Feed_Back_Link") {
      try {
        if (this.SM_Row.filter(e => e.S_Variable == data).length > 0) {
          this.Feed_Back_Link = this.SM_Row.filter(e => e.S_Variable == data)[0].S_Value;
        }

      } catch { }

    }
    else if (data == "Print_Type") {
      try {
        if (this.SM_Row.filter(e => e.S_Variable == data).length > 0) {
          this.Print_Type = this.SM_Row.filter(e => e.S_Variable == data)[0].S_Value;
        }

      } catch { }

    }

    else if (data == "Link") {
      try {
        if (this.SM_Row.filter(e => e.S_Variable == data).length > 0) {
          this.Link = this.SM_Row.filter(e => e.S_Variable == data)[0].S_Value;
        }

      } catch { }

    }
    else if (data == "Lable_Reports") {
      try {
        if (this.SM_Row.filter(e => e.S_Variable == data).length > 0) {
          this.Lable_Reports = this.SM_Row.filter(e => e.S_Variable == data)[0].S_Value;
        }

      } catch { }

    }


  }

  get_Setting_Setting() {
    this.getc("Api/Common/Get_Setting_Master").subscribe((res: any) => {
      this.SM_Row = JSON.parse(res).record;

      try {
        for (var i = 0; i < this.SM_Row.length; i++) {
          this.get_variable_Value(this.SM_Row[i]["S_Variable"]);
        }
      } catch { }

      this.Load_Defaults();

    });

  }




  Load_Defaults() {


    this.getc("Api/Master/get_reference").subscribe((res: any) => {
      this.Reference_Rows = JSON.parse(res).record;
      this.Reference_Rows.sort((a, b) => a["label"].localeCompare(b["label"]))

      this.Sales_Person = this.Current_User.UM_User_Name;
      this.CREATED_BY = this.Current_User.UM_User_Name;
      this.Rights_ID = this.Current_User.UM_Rights;


      this.Emp_ID = this.Current_User.Emp_ID;

      this.Emp_Name = this.Current_User.UM_Full_Name;
      this.get_Role_Rights(this.Current_User.UM_Rights);




      try {
        this.Prow = this.Reference_Rows.filter(e => e.Ref_ID == "User_Role");


        this.Rights_Name = this.Prow.filter(e => e.RGV_iID.toLowerCase() == this.Current_User.UM_Rights)[0].RGV_vDesciption;
        this.U_Rights = this.Rights_Name.toLowerCase();

        this.Header_Disp = this.Current_User.CM_Name;


        if (!(this.Rights_Name.toLowerCase() == "admin")) {
          this.Search_User = this.Current_User.UM_User_Name;
        }

      } catch (ex) {



      }




      try {

        this.page = this.Prow.filter(e => e.RGV_iID.toLowerCase() == this.Current_User.UM_Rights)[0].RGV_vCode;
        this.Lab_Home_Page = this.page;
      } catch (e) {
        console.log(e)
      }
    });
  }




  get_ref(data) {
    try {
      return this.Reference_Rows.filter(e => e.Ref_ID == data);
    } catch {
      return [];
    }
  }
  get_ref_lable(data) {



    try {
      return this.Reference_Rows.filter(e => e.value == data)[0]["label"];
    } catch {

      return "";
    }
  }
  get_child(parent) {
    var data = this.Menu_Rows.filter(e => e.Parent_ID == parent).sort((a, b) => Number(a["Order_No"]) - Number((b["Order_No"])));

    return data;
  }

  get_childs(parent) {
    var data = this.Menu_Rows.filter(e => e.Module == parent).sort((a, b) => Number(a["Order_No"]) - Number((b["Order_No"])));

    return data;
  }

  public Menu_data = "";
  public Menu_Master_Rows = [];
  public Parent_Menus = [];
  get_Menu_Master() {
    this.getc("Api/Setting/get_Menu_master").subscribe((res: any) => {
      this.applyMenuMaster(res);
    });
  }




  public Item_Master_Rows = [];
  public company_master = [];



  loading = false;

  public Perment_Item_Master_Row = [];
  public Reset_Item_Master_Row = [];


  public Item_Orderby_Name = "Part_No";
  public Item_Orderby_Product = "Item_Name";
  public Hod_ID = "";
  get_Company_Master() {



    this.getc("Api/Common/get_companys").subscribe((res: any) => {
      this.company_master = JSON.parse(res).record;



    });
  }



  public Items_Rows = [];
  public I_Category = "All";
  public I_Category2 = "All";
  public I_Ledger_Name = "All";

  public I_Brand = "All";
  public I_Item = "";
  public I_Group = "";

  get_Items() {

    this.loading = true;
    this.isload = true;
    this.Items_Rows = [];
    this.get("Api/Master/get_Items?Category=" + this.I_Category + "&Brand=" + this.I_Brand + "&Item=" + this.I_Item + "&Order_by=" + this.Item_Orderby_Name).subscribe((res: any) => {
      this.Items_Rows = JSON.parse(res).record;

      this.loading = false;
      this.isload = false;


    });
  }
  public DO_Delivery_Rows = [];
  get_Upload_DO_Delivery() {
    this.loading = true;
    this.isload = true;
    this.DO_Delivery_Rows = [];
    this.get("Api/Invoice/get_DO_Delivery_Details?").subscribe((res: any) => {
      this.DO_Delivery_Rows = JSON.parse(res).record;
      this.loading = false;
      this.isload = false;
    });
  }
  Item_Type_ = "Gear Box"
  public Item_Row_Cout = 0;
  public Item_Master_RM_Rows = [];

  public RM_all_item: boolean = true;
  get_Item_Master() {

    this.loading = true;
    this.isload = true;
    this.Item_Master_Rows = [];
    this.getc("Api/Master/get_Item_Master_Details").subscribe((res: any) => {
      this.Item_Master_Rows = JSON.parse(res).record;

      this.Perment_Item_Master_Row = JSON.parse(res).record;
      this.Reset_Item_Master_Row = JSON.parse(res).record;



      this.loading = false;
      this.isload = false;


      try {
        this.Item_Row_Cout = this.Item_Master_Rows.length;

      } catch { }


    });
  }

  public Day_Summary: any = {};
  Week_Per = 0;
  Day_Per = 0;
  Month_Per = 0;
  get_Day_Summary() {
    this.Week_Per = 0;
    this.Day_Per = 0;
    this.Month_Per = 0;
    this.get("Api/Master/pr_get_Day_Summary?Date=" + this.T_Date).subscribe((res: any) => {
      this.Day_Summary = JSON.parse(res).record[0];
      this.Week_Per = this.Day_Summary.Week_Per;
      this.Day_Per = this.Day_Summary.Day_Per;
      this.Month_Per = this.Day_Summary.Month_Per;
      var W = "";
      W = this.Week_Per + "";
      localStorage.setItem('Week_Per', W);

      var D = "";
      D = this.Day_Per + "";
      localStorage.setItem('Day_Per', D);


      var M = "";
      M = this.Month_Per + "";
      localStorage.setItem('Month_Per', M);
    });

  }

  Full_Screen: boolean = false;
  fullWithTableDisplay() {
    let tableZoomWindow = document.getElementById('table-window-zoom');
    const isSmallScreenIcon = document.getElementById('change-icon');
    if (document.fullscreenElement) {
      tableZoomWindow.classList.remove('Full_Screen');
      isSmallScreenIcon.classList.replace("bx-collapse", "bx-fullscreen");
      document.exitFullscreen();
      this.Full_Screen = true;
    }
    else {
      tableZoomWindow.classList.add('Full_Screen');
      isSmallScreenIcon.classList.replace("bx-fullscreen", "bx-collapse");
      document.documentElement.requestFullscreen();
      this.Full_Screen = false;
    }
  }
  stgPlanFullWidthTable() {
    this.fullWithTableDisplay();
  }
  stagWiseFullScreen() {
    this.fullWithTableDisplay();
  }
  isdailyReviewTableWindow() {
    this.fullWithTableDisplay();
  }
  public Head_Assignment = [];
  get_Head_Assignment() {

    this.loading = true;
    this.isload = true;
    this.Head_Assignment = [];
    this.get("Api/Master/get_Head_Assignment?").subscribe((res: any) => {
      this.Head_Assignment = JSON.parse(res).record;


      this.loading = false;
      this.isload = false;


      // console.log(this.Item_Category);
    });
  }
  public Item_Master_Rows1 = [];
  get_Price_Item_Master1() {

    this.loading = true;
    this.isload = true;
    this.Item_Master_Rows1 = [];
    this.get("Api/Master/get_Price_List?I_Category=" + this.I_Category).subscribe((res: any) => {
      this.Item_Master_Rows1 = JSON.parse(res).record;

      this.Perment_Item_Master_Row = JSON.parse(res).record;
      this.Reset_Item_Master_Row = JSON.parse(res).record;







      this.loading = false;
      this.isload = false;


      try {
        this.Item_Row_Cout = this.Item_Master_Rows.length;

      } catch { }

      this.Item_Category = [...new Set(this.Item_Master_Rows.map(item => item.Category))];

      // console.log(this.Item_Category);
    });
  }

  Loss_Count = 0;
  Res_Closed_Count = 0;
  public Reswise_Pending_Rows = [];
  Res_Pending_Count = 0;
  Res_Loss_Qty = 0;
  Res_Loss_min = 0;
  get_Res_Wise_Pending() {
    this.loading = true;
    this.isload = true;
    this.Res_Loss_Qty = 0;
    this.Res_Loss_min = 0;
    this.Reswise_Pending_Rows = [];
    this.Res_Pending_Count = 0;
    this.Loss_Count = 0;

    this.get("Api/Invoice/get_Responsabilitywise_Pending?date=" + this.T_Year + "-" + this.T_Month + "-01" + "&Loss_Responsibility=" + this.Loss_Responsibility).subscribe((res: any) => {
      this.Reswise_Pending_Rows = JSON.parse(res).record;
      this.loading = false;
      this.isload = false;
      this.Res_Loss_Qty = (this.Reswise_Pending_Rows.reduce((sum, current) => sum + parseFloat(current.Loss_Qty), 0)).toFixed(0);;
      this.Res_Loss_min = (this.Reswise_Pending_Rows.reduce((sum, current) => sum + parseFloat(current.Loss_Minute), 0)).toFixed(0);

      try {
        this.Res_Pending_Count = this.Reswise_Pending_Rows.length;
        this.Loss_Count = this.Res_Pending_Count + this.Res_Closed_Count;
      } catch { }
    });
  }







  public Reswise_Closed_Rows = [];


  get_Res_Wise_Closed() {
    this.loading = true;
    this.isload = true;
    this.Res_Loss_Qty = 0;
    this.Res_Loss_min = 0;
    this.Reswise_Closed_Rows = [];
    this.Res_Closed_Count = 0;
    this.Loss_Count = 0;

    this.get("Api/Invoice/get_Responsabilitywise_Closed?date=" + this.T_Year + "-" + this.T_Month + "-01" + "&Loss_Responsibility=" + this.Loss_Responsibility).subscribe((res: any) => {
      this.Reswise_Closed_Rows = JSON.parse(res).record;
      this.loading = false;
      this.isload = false;
      this.Res_Loss_Qty = (this.Reswise_Closed_Rows.reduce((sum, current) => sum + parseFloat(current.Loss_Qty), 0)).toFixed(0);;
      this.Res_Loss_min = (this.Reswise_Closed_Rows.reduce((sum, current) => sum + parseFloat(current.Loss_Minute), 0)).toFixed(0);

      try {
        this.Res_Closed_Count = this.Reswise_Closed_Rows.length;
        this.Loss_Count = this.Res_Pending_Count + this.Res_Closed_Count;
      } catch { }
    });
  }
  public Cash_Settlement = [];

  public Cash_Settlement_Rows = [];
  get_Cash_Settlement() {

    this.loading = true;
    this.isload = true;
    this.Cash_Settlement_Rows = [];
    this.get("Api/Invoice/get_Cash_Settlement?From=" + this.S_From + "&To=" + this.S_To + "&Sales_person=" + this.S_Sales + "&User=" + this.Search_User + "&Area=" + this.S_Area + "&order_by=x.Bill_No desc").subscribe((res: any) => {

      this.Cash_Settlement_Rows = JSON.parse(res).record;







      this.loading = false;
      this.isload = false;



      // console.log(this.Item_Category);
    });
  }



  public get_Reprint_Packing_Rows = [];
  get_Reprint_Pacikng_Details() {

    this.get("Api/master/get_Reprint_Packing_Details?From=" + this.S_From + "&To=" + this.S_To).subscribe((res: any) => {
      this.get_Reprint_Packing_Rows = JSON.parse(res).record;
    });
  }


  public Qty
  public Over_Due_Count = 0;
  public Over_Due_Rows = [];
  public Over_Due_Rows_P = [];
  get_Over_Due_Details() {

    this.getc("Api/master/get_Over_Due_Details").subscribe((res: any) => {
      this.Over_Due_Rows = JSON.parse(res).record;
      this.Over_Due_Rows_P = JSON.parse(res).record;

      try {
        this.Over_Due_Count = this.Over_Due_Rows_P.length;
        this.Qty = (this.Over_Due_Rows.reduce((sum, current) => sum + parseFloat(current.Qty), 0)).toFixed();


      } catch { }
    });
  }



  public SFGPacking_Rows = [];
  get_SFGPacikng_Details() {

    this.get("Api/master/get_SFGPacking_Details?From=" + this.S_From + "&To=" + this.S_To).subscribe((res: any) => {
      this.SFGPacking_Rows = JSON.parse(res).record;
    });
  }


  public Label_Rows = [];
  get_Label_Rows() {
    this.Label_Rows = [];
    this.get("Api/master/get_DO_Printed_Details?From=" + this.S_From + "&To=" + this.S_To).subscribe((res: any) => {
      this.Label_Rows = JSON.parse(res).record;
    });
  }


  get_Label_Rows_s(data) {
    this.Label_Rows = [];
    this.get("Api/master/get_DO_Printed_Details_S?Data=" + data).subscribe((res: any) => {
      this.Label_Rows = JSON.parse(res).record;
    });
  }



  public get_Packing_Details_Rows = [];
  get_Packing_Details() {

    this.get("Api/master/get_Packing_Details?From=" + this.S_From + "&To=" + this.S_To).subscribe((res: any) => {
      this.get_Packing_Details_Rows = JSON.parse(res).record;
    });
  }
  public Disptched_Dashboard_Rows = [];
  public Disptched_Dashboard_count = 0;

  get_Disptched_Dashboard() {
    this.Disptched_Dashboard_Rows = [];
    this.Disptched_Dashboard_count = 0;
    this.get("Api/master/get_Dispatched_Dashboard?From=" + this.S_From + "&To=" + this.S_To).subscribe((res: any) => {
      this.Disptched_Dashboard_Rows = JSON.parse(res).record;
      try {
        this.Disptched_Dashboard_count = this.Disptched_Dashboard_Rows.length;

      } catch { }
    });
  }
  public Reset_Product_Master_Rows = [];
  public Perment_Product_Master_Rows = [];
  public Product_Master_Rows = [];
  public Product_Row_Cout = 0;
  public Product_Master_RM_Rows = [];
  get_Product_Master() {

    this.loading = true;
    this.isload = true;
    this.Product_Master_Rows = [];
    this.get("Api/Master/get_Product_Master?Order_by=" + this.Item_Orderby_Product).subscribe((res: any) => {
      this.Product_Master_Rows = JSON.parse(res).record;

      this.Perment_Product_Master_Rows = JSON.parse(res).record;
      this.Reset_Product_Master_Rows = JSON.parse(res).record;

      this.Product_Master_RM_Rows = this.Perment_Product_Master_Rows.filter(e => e.Item_Group == "2");
      console.log(this.Product_Master_RM_Rows);
      this.loading = false;
      this.isload = false;


      try {
        this.Product_Row_Cout = this.Product_Master_Rows.length;

      } catch { }

      //   this.Item_Category = [...new Set(this.Item_Master_Rows.map(item => item.Category))];

      // console.log(this.Item_Category);
    });
  }
  public BOM_Master_Rows = [];
  public FG_ID = "0";
  get_BOM_Master() {
    this.loading = true;
    this.isload = true;
    this.BOM_Master_Rows = [];
    this.get("Api/Master/get_BOM_Master_By_FG?FG_ID=" + this.FG_ID + "&Order_by=RM_Order").subscribe((res: any) => {
      this.BOM_Master_Rows = JSON.parse(res).record;
      this.loading = false;
      this.isload = false;
    });
  }

  public Table_Master_Rows = [];
  public Perment_Table_Master_Rows = [];
  public Reset_Table_Master_Row = [];
  public Table_Orderby_Name = "Name";


  Num(data) {
    return Number(data).toFixed(2);
  }


  get_Table_Master() {
    this.loading = true;
    this.isload = true;
    this.Table_Master_Rows = [];
    this.get("Api/Master/get_Table_Master?Order_by=" + this.Table_Orderby_Name).subscribe((res: any) => {
      this.Table_Master_Rows = JSON.parse(res).record;
      this.Perment_Table_Master_Rows = JSON.parse(res).record;
      this.Reset_Table_Master_Row = JSON.parse(res).record;
      this.loading = false;
      this.isload = false;
      //   this.Item_Category = [...new Set(this.Item_Master_Rows.map(item => item.Category))];

      // console.log(this.Item_Category);
    });
  }

  public Seraial_No_Settings_Rows = [];
  public Perment_Seraial_No_Settings_Rows = [];
  public Reset_Seraial_No_Settings_Row = [];
  public Orderby_Name = "Name";

  get_Seraial_No_Settings() {

    this.loading = true;
    this.isload = true;
    this.Seraial_No_Settings_Rows = [];
    this.get("Api/Setting/get_Seraial_No_Settings?Order_by=" + this.Orderby_Name).subscribe((res: any) => {
      this.Seraial_No_Settings_Rows = JSON.parse(res).record;
      this.Perment_Seraial_No_Settings_Rows = JSON.parse(res).record;
      this.Reset_Seraial_No_Settings_Row = JSON.parse(res).record;
      this.loading = false;
      this.isload = false;
      //   this.Item_Category = [...new Set(this.Item_Master_Rows.map(item => item.Category))];

      // console.log(this.Item_Category);
    });
  }
  public Variable_Settings_Rows = [];
  public Perment_Variable_Settings_Rows = [];
  public Reset_Variable_Settings_Row = [];

  get_Variable_Settings() {

    this.loading = true;
    this.Variable_Settings_Rows = [];
    this.getc("Api/Setting/get_variable_Settings").subscribe((res: any) => {
      this.Variable_Settings_Rows = JSON.parse(res).record;
      this.Perment_Variable_Settings_Rows = JSON.parse(res).record;
      this.Reset_Variable_Settings_Row = JSON.parse(res).record;
      this.loading = false;

    });
  }


  public load_from_make_invoice: boolean = false;
  public Stcok_Row = [];
  public P_Stcok_Row = [];
  public item_Category_ = "";
  get_Item_Master1(id) {
    this.Stcok_Row = [];
    this.loading = true;
    this.get("Api/Master/get_Item_Stock_bycustomer1?Ledger_ID=" + id + "&Category=" + this.item_Category_ + "&Check_Stock=" + this.Check_Stock + "&Order_by= x.Category,Item_Name&Order_No=" + this.Order_No).subscribe((res: any) => {
      this.Stcok_Row = JSON.parse(res).record;
      this.P_Stcok_Row = JSON.parse(res).record;
      this.loading = false;
      this.load_Temp_Order_Row()
    });
  }


  load_Temp_Order_Row() {

    try {
      var Qty = 0;
      var Rate = 0;
      var Free = 0;
      this.Stcok_Row.forEach(x => x.Model = "0");

      for (var i = 0; i < this.Stcok_Row.length; i++) {
        try {

          Qty = this.Temp_Order_Row.filter(e => e.Uni_Code == this.Stcok_Row[i]["Uni_Code"]).filter(e => e.Item_ID == this.Stcok_Row[i]["Item_ID"])[0]["Order_Qty"];
          Rate = this.Temp_Order_Row.filter(e => e.Uni_Code == this.Stcok_Row[i]["Uni_Code"]).filter(e => e.Item_ID == this.Stcok_Row[i]["Item_ID"])[0]["Order_Rate"];
          Free = this.Temp_Order_Row.filter(e => e.Uni_Code == this.Stcok_Row[i]["Uni_Code"]).filter(e => e.Item_ID == this.Stcok_Row[i]["Item_ID"])[0]["Free"];

          Qty = parseFloat(Qty.toString());
          Rate = parseFloat(Rate.toString());
          Free = parseFloat(Free.toString());

        } catch {

          Qty = 0;
          Rate = 0;
          Free = 0;
        }


        if (Rate > 0) {
          this.Stcok_Row[i]["Order_Rate"] = Rate;
        }

        if (Qty > 0) {
          this.Stcok_Row[i]["Order_Qty"] = Qty;
          this.Stcok_Row[i]["Model"] = Qty;

        }

        if (Free > 0) {
          this.Stcok_Row[i]["Free"] = Free;
        }


      }
    } catch { }



    this.Stcok_Row = this.Stcok_Row.sort((b, a) => Number(a["Model"]) - Number((b["Model"])));



  }

  public header_Row: any = {}
  public Details_Row = [];

  public Temp_Order_Row = [];

  add_one: number = 1;
  remove_one: number = -1;

  public Tax_Type = "exclusive";
  public GST_Type = "local";
  public cart_item = [

  ];

  /*{
  BAG: "1",
  CGST_PER: 0,
  CGST_TAX_AMT: 0,
  CUS_FREE: "0",
  DESCRIPTION: "bottle of 60 capsules",
  DISC_AMT: "0",
  DISC_PER: "0",
  DISC_TYPE: "",
  GST_PER: "0.00",
  HSNCode: "-",
  IGST_PER: 0,
  IGST_TAX_AMT: 0,
  ITEM_ID: "5",
  ITEM_NAME: "Inlife Green Tea Extract 500mg ",
  MRP: "0.00",
  NET_AMT: 870,
  NET_RATE: "290.00",
  PURCHASE_RATE: "0.000",
  Qty: 3,
  RESALE_RATE: "0.00",
  SALE_RATE: "290.00",
  SGST_PER: 0,
  SGST_TAX_AMT: 0,
  SOC_FREE: "0",
  TAXABLE_AMT: 870,
  TAX_REVYES: "",
  TAX_TYPE: "",
  TAX_YESNO: "",
  TOTAL_TAX: 0,
  TOT_AMT: 870,
  UNIT: "2"
  },
  {
  BAG: "1",
  CGST_PER: 0,
  CGST_TAX_AMT: 0,
  CUS_FREE: "0",
  DESCRIPTION: "bottle of 60 capsules",
  DISC_AMT: "0",
  DISC_PER: "0",
  DISC_TYPE: "",
  GST_PER: "0.00",
  HSNCode: "-",
  IGST_PER: 0,
  IGST_TAX_AMT: 0,
  ITEM_ID: "5",
  ITEM_NAME: "Inlife Green Tea Extract 500mg ",
  MRP: "0.00",
  NET_AMT: 870,
  NET_RATE: "290.00",
  PURCHASE_RATE: "0.000",
  Qty: 3,
  RESALE_RATE: "0.00",
  SALE_RATE: "290.00",
  SGST_PER: 0,
  SGST_TAX_AMT: 0,
  SOC_FREE: "0",
  TAXABLE_AMT: 870,
  TAX_REVYES: "",
  TAX_TYPE: "",
  TAX_YESNO: "",
  TOTAL_TAX: 0,
  TOT_AMT: 870,
  UNIT: "2"
  }
  ];  
  */


  Clear_Cart() {

    this.Selected_Customer = {};
    this.cart_item = [];
    try {
      this.Item_Master_Rows.forEach(x => x.Order_Qty = "0");
      // this.Item_Master_Rows.forEach(x => x.Rate = "0");
      // this.Item_Master_Rows.forEach(x => x.Rate = "0");
    } catch { }

  }




  Clear_Order_Cart() {

    this.Selected_Customer = {};
    this.cart_item = [];
    try {
      this.Item_Master_Rows.forEach(x => x.Order_Qty = "0");
      this.Perment_Item_Master_Row.forEach(x => x.Order_Qty = "0");

      this.Item_Master_Rows.forEach(x => x.Description = "");
      this.Perment_Item_Master_Row.forEach(x => x.Description = "");

    } catch { }

  }

  public load(data) {
    this.router.navigate([data], { replaceUrl: true });
  }

  public loadpage1(data) {
    this.router.navigate([data]);
  }




  public assign = "Assign";

  public Pack = "Pack";

  _item1(data, qty, pack, rate) {


    var qty_ = 0;
    var index = this.Item_Master_Rows.findIndex(function (item, i) {
      return item.ID === data.ID
    });


    var bag_Qty = this.Item_Master_Rows[index]["Bag_Qty"];

    if (index > -1) {

      qty_ = (Number(pack) * Number(bag_Qty)) + Number(qty);


      this.Item_Master_Rows[index]["Order_Qty"] = qty_;
      this.Item_Master_Rows[index]["Rate"] = rate;
      this.Item_Master_Rows[index]["Bag"] = pack;
      this.Item_Master_Rows[index]["Qty"] = qty;

      var inx = this.Perment_Item_Master_Row.findIndex(function (item, i) {
        return item.ID === data.ID
      });

      this.Perment_Item_Master_Row[inx]["Order_Qty"] = qty_;


      var ID = "";
      ID = this.Item_Master_Rows[index]["ID"];
      if (this.cart_item.length > 0) {
        var Temp_Index = this.cart_item.findIndex(function (item, i) {
          return item.ITEM_ID == ID;

        });

        if (Temp_Index > -1) {
          this.cart_item.splice(Temp_Index, 1);
        }
      }
    }




    var Disc_Rate = rate;
    var GST_per = data.GST_Per;
    var Final_Rate = 0.00;
    var Final_AMT = 0.00;
    var IGST_AMT = 0.00;
    var SGST_AMT = 0.00;
    var CGST_AMT = 0.00;

    var IGST_Per = 0.00;
    var SGST_Per = 0.00;
    var CGST_Per = 0.00;

    if (this.Tax_Type.toLowerCase() == "inclusive") {
      Final_Rate = (Number(Disc_Rate) / (100 + Number(GST_per))) * 100;
      Final_AMT = ((Number(Disc_Rate) / (100 + Number(GST_per))) * 100) * Number(qty_);
    }
    else {
      Final_Rate = Number(Disc_Rate);
      Final_AMT = Number(Disc_Rate) * Number(qty_);
    }

    if (this.GST_Type.toLowerCase() == "local") {
      IGST_AMT = 0.00;
      SGST_AMT = ((Number(Final_Rate) * Number(qty_)) / 100) * (Number(GST_per) / 2);
      CGST_AMT = ((Number(Final_Rate) * Number(qty_)) / 100) * (Number(GST_per) / 2);


      IGST_Per = 0.00;
      SGST_Per = (Number(GST_per) / 2);
      CGST_Per = (Number(GST_per) / 2);
    }
    else {
      IGST_AMT = ((Number(Final_Rate) * Number(qty_)) / 100) * (Number(GST_per));
      SGST_AMT = 0.00;
      CGST_AMT = 0.00;


      IGST_Per = (Number(GST_per));
      SGST_Per = 0.00;
      CGST_Per = 0.00;
    }





    var Temp_data = {

      'ITEM_ID': data.value,

      'ITEM_CODE': data.Part_No,
      'ITEM_NAME': data.label,
      'DESCRIPTION': data.Description,
      'HSNCode': data.HSN_Code,
      'UNIT': data.UOM,
      'BAG': '1',
      'Qty': qty_,
      'PURCHASE_RATE': data.Purchase_Rate,
      'RESALE_RATE': data.Wholesale_Rate,
      'SALE_RATE': rate,
      'MRP': data.compareAtPrice,
      'CUS_FREE': '0',
      'SOC_FREE': '0',
      'NET_RATE': rate,
      'TOT_AMT': Number(rate) * Number(qty_),
      'DISC_TYPE': '',
      'DISC_PER': '0',
      'DISC_AMT': '0',
      'TAXABLE_AMT': Final_AMT,
      'TAX_YESNO': '',
      'TAX_REVYES': '',
      'TAX_TYPE': '',
      'Bag': pack,
      'Pcs': qty,
      'GST_PER': data.GST_Per,
      'CGST_PER': CGST_Per,
      'SGST_PER': SGST_Per,
      'IGST_PER': IGST_Per,
      'CGST_TAX_AMT': CGST_AMT,
      'SGST_TAX_AMT': SGST_AMT,
      'IGST_TAX_AMT': IGST_AMT,
      'TOTAL_TAX': Number(CGST_AMT) + Number(SGST_AMT) + Number(IGST_AMT),
      'NET_AMT': Number(Final_AMT) + Number(CGST_AMT) + Number(SGST_AMT) + Number(IGST_AMT)
    }

    if (qty_ > 0) {
      this.cart_item.push(Temp_data)
    }

    this.cart_item.sort((a, b) => a["ITEM_NAME"].localeCompare(b["ITEM_NAME"]))

    this.C_Sub_Total = (this.cart_item.reduce((sum, current) => sum + parseFloat(current.NET_AMT), 0)).toFixed(2);

    this.C_Taxable = (this.cart_item.reduce((sum, current) => sum + parseFloat(current.TAXABLE_AMT), 0)).toFixed(2);
    this.C_IGST = (this.cart_item.reduce((sum, current) => sum + parseFloat(current.IGST_TAX_AMT), 0)).toFixed(2);
    this.C_SGST = (this.cart_item.reduce((sum, current) => sum + parseFloat(current.SGST_TAX_AMT), 0)).toFixed(2);
    this.C_CGST = (this.cart_item.reduce((sum, current) => sum + parseFloat(current.CGST_TAX_AMT), 0)).toFixed(2);
    this.C_Tax = (this.cart_item.reduce((sum, current) => sum + parseFloat(current.TOTAL_TAX), 0)).toFixed(2);

    this.C_Total_Payable = (this.cart_item.reduce((sum, current) => sum + parseFloat(current.NET_AMT), 0)).toFixed(2);

    this.C_Savings = (this.cart_item.reduce((sum, current) => sum + ((parseFloat(current.MRP) - parseFloat(current.SALE_RATE)) * parseFloat(current.Qty)), 0)).toFixed(2);

  }


  add_item(data, qty) {




    var qty_ = 0;
    var index = this.Item_Master_Rows.findIndex(function (item, i) {
      return item.ID === data.ID
    });



    if (index > -1) {

      qty_ = Number(this.Item_Master_Rows[index]["Order_Qty"]) + Number(qty);

      this.Item_Master_Rows[index]["Order_Qty"] = qty_;
      var inx = this.Perment_Item_Master_Row.findIndex(function (item, i) {
        return item.ID === data.ID
      });

      this.Perment_Item_Master_Row[inx]["Order_Qty"] = qty_;


      var ID = "";
      ID = this.Item_Master_Rows[index]["ID"];
      if (this.cart_item.length > 0) {
        var Temp_Index = this.cart_item.findIndex(function (item, i) {
          return item.ITEM_ID == ID;

        });

        if (Temp_Index > -1) {
          this.cart_item.splice(Temp_Index, 1);
        }
      }
    }




    var Disc_Rate = data.Rate;
    var GST_per = data.GST_Per;
    var Final_Rate = 0.00;
    var Final_AMT = 0.00;
    var IGST_AMT = 0.00;
    var SGST_AMT = 0.00;
    var CGST_AMT = 0.00;

    var IGST_Per = 0.00;
    var SGST_Per = 0.00;
    var CGST_Per = 0.00;

    if (this.Tax_Type.toLowerCase() == "inclusive") {
      Final_Rate = (Number(Disc_Rate) / (100 + Number(GST_per))) * 100;
      Final_AMT = ((Number(Disc_Rate) / (100 + Number(GST_per))) * 100) * Number(qty_);
    }
    else {
      Final_Rate = Number(Disc_Rate);
      Final_AMT = Number(Disc_Rate) * Number(qty_);
    }

    if (this.GST_Type.toLowerCase() == "local") {
      IGST_AMT = 0.00;
      SGST_AMT = ((Number(Final_Rate) * Number(qty_)) / 100) * (Number(GST_per) / 2);
      CGST_AMT = ((Number(Final_Rate) * Number(qty_)) / 100) * (Number(GST_per) / 2);


      IGST_Per = 0.00;
      SGST_Per = (Number(GST_per) / 2);
      CGST_Per = (Number(GST_per) / 2);
    }
    else {
      IGST_AMT = ((Number(Final_Rate) * Number(qty_)) / 100) * (Number(GST_per));
      SGST_AMT = 0.00;
      CGST_AMT = 0.00;


      IGST_Per = (Number(GST_per));
      SGST_Per = 0.00;
      CGST_Per = 0.00;
    }








    var Temp_data = {

      'ITEM_ID': data.value,
      'ITEM_CODE': data.Item_Code,
      'ITEM_NAME': data.label,
      'DESCRIPTION': data.Description,
      'HSNCode': data.HSN_Code,
      'UNIT': data.UOM,
      'BAG': '1',
      'Qty': qty_,
      'PURCHASE_RATE': data.Purchase_Rate,
      'RESALE_RATE': data.Wholesale_Rate,
      'SALE_RATE': data.Rate,
      'MRP': data.compareAtPrice,
      'CUS_FREE': '0',
      'SOC_FREE': '0',
      'NET_RATE': data.Rate,
      'TOT_AMT': Number(data.Rate) * Number(qty_),
      'DISC_TYPE': '',
      'DISC_PER': '0',
      'DISC_AMT': '0',
      'TAXABLE_AMT': Number(data.Rate) * Number(qty_),
      'TAX_YESNO': '',
      'TAX_REVYES': '',
      'TAX_TYPE': '',
      'Bag': '1',
      'Pcs': '0',
      'GST_PER': data.GST_Per,
      'CGST_PER': CGST_Per,
      'SGST_PER': SGST_Per,
      'IGST_PER': IGST_Per,
      'CGST_TAX_AMT': CGST_AMT,
      'SGST_TAX_AMT': SGST_AMT,
      'IGST_TAX_AMT': IGST_AMT,
      'TOTAL_TAX': Number(CGST_AMT) + Number(SGST_AMT) + Number(IGST_AMT),
      'NET_AMT': (Number(data.Rate) * Number(qty_)) + Number(CGST_AMT) + Number(SGST_AMT) + Number(IGST_AMT)
    }

    if (qty_ > 0) {
      this.cart_item.push(Temp_data)
    }

    this.cart_item.sort((a, b) => a["ITEM_NAME"].localeCompare(b["ITEM_NAME"]))

    this.C_Sub_Total = (this.cart_item.reduce((sum, current) => sum + parseFloat(current.NET_AMT), 0)).toFixed(2);

    this.C_Taxable = (this.cart_item.reduce((sum, current) => sum + parseFloat(current.TAXABLE_AMT), 0)).toFixed(2);
    this.C_IGST = (this.cart_item.reduce((sum, current) => sum + parseFloat(current.IGST_TAX_AMT), 0)).toFixed(2);
    this.C_SGST = (this.cart_item.reduce((sum, current) => sum + parseFloat(current.SGST_TAX_AMT), 0)).toFixed(2);
    this.C_CGST = (this.cart_item.reduce((sum, current) => sum + parseFloat(current.CGST_TAX_AMT), 0)).toFixed(2);
    this.C_Tax = (this.cart_item.reduce((sum, current) => sum + parseFloat(current.TOTAL_TAX), 0)).toFixed(2);

    this.C_Total_Payable = (this.cart_item.reduce((sum, current) => sum + parseFloat(current.NET_AMT), 0)).toFixed(2);

    this.C_Savings = (this.cart_item.reduce((sum, current) => sum + ((parseFloat(current.MRP) - parseFloat(current.SALE_RATE)) * parseFloat(current.Qty)), 0)).toFixed(2);

  }


  add_item2(data, qty, pack, rate) {


    var qty_ = 0;
    var index = this.Item_Master_Rows.findIndex(function (item, i) {
      return item.ID == data.ID
    });



    var bag_Qty = this.Item_Master_Rows[index]["Bag_Qty"];

    if (index > -1) {

      qty_ = (Number(pack) * Number(bag_Qty)) + Number(qty);


      this.Item_Master_Rows[index]["Order_Qty"] = qty_;
      this.Item_Master_Rows[index]["Rate"] = rate;
      this.Item_Master_Rows[index]["Bag"] = pack;
      this.Item_Master_Rows[index]["Qty"] = qty;

      var inx = this.Perment_Item_Master_Row.findIndex(function (item, i) {
        return item.ID === data.ID
      });

      this.Perment_Item_Master_Row[inx]["Order_Qty"] = qty_;


      var ID = "";
      ID = this.Item_Master_Rows[index]["ID"];
      if (this.cart_item.length > 0) {
        var Temp_Index = this.cart_item.findIndex(function (item, i) {
          return item.ITEM_ID == ID;

        });

        if (Temp_Index > -1) {
          this.cart_item.splice(Temp_Index, 1);
        }
      }
    }




    var Disc_Rate = data.Rate;
    var GST_per = data.GST_Per;
    var Final_Rate = 0.00;
    var Final_AMT = 0.00;
    var IGST_AMT = 0.00;
    var SGST_AMT = 0.00;
    var CGST_AMT = 0.00;

    var IGST_Per = 0.00;
    var SGST_Per = 0.00;
    var CGST_Per = 0.00;

    if (this.Tax_Type.toLowerCase() == "inclusive") {
      Final_Rate = (Number(Disc_Rate) / (100 + Number(GST_per))) * 100;
      Final_AMT = ((Number(Disc_Rate) / (100 + Number(GST_per))) * 100) * Number(qty_);
    }
    else {
      Final_Rate = Number(Disc_Rate);
      Final_AMT = Number(Disc_Rate) * Number(qty_);
    }

    if (this.GST_Type.toLocaleUpperCase() == "local") {
      IGST_AMT = 0.00;
      SGST_AMT = ((Number(Final_Rate) * Number(qty_)) / 100) * (Number(GST_per) / 2);
      CGST_AMT = ((Number(Final_Rate) * Number(qty_)) / 100) * (Number(GST_per) / 2);


      IGST_Per = 0.00;
      SGST_Per = (Number(GST_per) / 2);
      CGST_Per = (Number(GST_per) / 2);
    }
    else {
      IGST_AMT = ((Number(Final_Rate) * Number(qty_)) / 100) * (Number(GST_per));
      SGST_AMT = 0.00;
      CGST_AMT = 0.00;


      IGST_Per = (Number(GST_per));
      SGST_Per = 0.00;
      CGST_Per = 0.00;
    }





    var Temp_data = {

      'ITEM_ID': data.value,
      'ITEM_CODE': data.Part_No,
      'ITEM_NAME': data.label,
      'DESCRIPTION': data.Description,
      'HSNCode': data.HSN_Code,
      'UNIT': data.UOM,
      'BAG': '1',
      'Qty': qty_,
      'PURCHASE_RATE': data.Purchase_Rate,
      'RESALE_RATE': data.Wholesale_Rate,
      'SALE_RATE': rate,
      'MRP': data.compareAtPrice,
      'CUS_FREE': '0',
      'SOC_FREE': '0',
      'NET_RATE': rate,
      'TOT_AMT': Number(rate) * Number(qty_),
      'DISC_TYPE': '',
      'DISC_PER': '0',
      'DISC_AMT': '0',
      'TAXABLE_AMT': Final_AMT,
      'TAX_YESNO': '',
      'TAX_REVYES': '',
      'TAX_TYPE': '',
      'Bag': pack,
      'Pcs': qty,
      'GST_PER': data.GST_Per,
      'CGST_PER': CGST_Per,
      'SGST_PER': SGST_Per,
      'IGST_PER': IGST_Per,
      'CGST_TAX_AMT': CGST_AMT,
      'SGST_TAX_AMT': SGST_AMT,
      'IGST_TAX_AMT': IGST_AMT,
      'TOTAL_TAX': Number(CGST_AMT) + Number(SGST_AMT) + Number(IGST_AMT),
      'NET_AMT': Number(Final_AMT) + Number(CGST_AMT) + Number(SGST_AMT) + Number(IGST_AMT)
    }

    if (qty_ > 0) {
      this.cart_item.push(Temp_data)
    }

    this.cart_item.sort((a, b) => a["ITEM_NAME"].localeCompare(b["ITEM_NAME"]))

    this.C_Sub_Total = (this.cart_item.reduce((sum, current) => sum + parseFloat(current.NET_AMT), 0)).toFixed(2);

    this.C_Taxable = (this.cart_item.reduce((sum, current) => sum + parseFloat(current.TAXABLE_AMT), 0)).toFixed(2);
    this.C_IGST = (this.cart_item.reduce((sum, current) => sum + parseFloat(current.IGST_TAX_AMT), 0)).toFixed(2);
    this.C_SGST = (this.cart_item.reduce((sum, current) => sum + parseFloat(current.SGST_TAX_AMT), 0)).toFixed(2);
    this.C_CGST = (this.cart_item.reduce((sum, current) => sum + parseFloat(current.CGST_TAX_AMT), 0)).toFixed(2);
    this.C_Tax = (this.cart_item.reduce((sum, current) => sum + parseFloat(current.TOTAL_TAX), 0)).toFixed(2);

    this.C_Total_Payable = (this.cart_item.reduce((sum, current) => sum + parseFloat(current.NET_AMT), 0)).toFixed(2);

    this.C_Savings = (this.cart_item.reduce((sum, current) => sum + ((parseFloat(current.MRP) - parseFloat(current.SALE_RATE)) * parseFloat(current.Qty)), 0)).toFixed(2);

  }



  Search_Item_Category(data) {

    console.log(data);
    this.Selected_item_Category = data;
    if (data == "All") {
      this.Item_Master_Rows = this.Perment_Item_Master_Row;

    }
    else {
      this.Item_Master_Rows = this.Perment_Item_Master_Row.filter(e => e.Category.toLowerCase().includes(data.toLowerCase()));
    }

  }



  public Room_Check_OUT_Rows = [];
  get_Room_Check_out() {
    this.getc("Api/Transaction/get_Room_Check_OUT").subscribe((res: any) => {
      this.Room_Check_OUT_Rows = JSON.parse(res).record;
    });
  }




  public Advance_Collection_Rows = [];
  get_Advance_Collection() {
    this.get("Api/Transaction/get_Advance_Collection?From=" + this.From_Date.formatted + "&To=" + this.To_Date.formatted).subscribe((res: any) => {
      this.Advance_Collection_Rows = JSON.parse(res).record;
    });
  }

  public Room_Check_IN_Rows = [];
  get_Room_Check_IN() {
    this.getc("Api/Transaction/get_Room_Check_IN").subscribe((res: any) => {
      this.Room_Check_IN_Rows = JSON.parse(res).record;
    });
  }
  public Schedule_count = 0;

  public ledger_count = 0;
  public Ledger_Order_by = "created_date desc";
  public Ledger_Master_Rows = [];
  public PLedger_Master_Rows = [];
  public SLedger_Rows = [];
  public LedgerLoad: boolean = false;

  get_Ledger_Master() {
    this.LedgerLoad = true;

    this.isload = true;
    this.Ledger_Master_Rows = [];
    this.get("Api/Master/get_Ledger_Master1?Lfrom=" + this.Lfrom + "&Area=" + this.S_Area + "&Order=" + this.Ledger_Order_by).subscribe((res: any) => {
      this.isload = false;
      this.LedgerLoad = false;

      this.Ledger_Master_Rows = JSON.parse(res).record;
      this.PLedger_Master_Rows = JSON.parse(res).record;

      this.ledger_Filter();
      try {
        this.ledger_count = this.Ledger_Master_Rows.length;
      } catch { }
    });
  }

  public Request_Type = "All";
  public Problem_Type = "All"
  public Quality_Flash_Rows = [];
  get_Quality_Flash() {
    this.isload = true;
    this.Quality_Flash_Rows = [];
    this.get("Api/Master/get_Quality_Flash_Details?").subscribe((res: any) => {
      this.Quality_Flash_Rows = JSON.parse(res).record;
      this.isload = false;

    });
  }



  public filter_data = "";











  public WTF_Printg = 0;
  public Upload_Delivery_Rows = [];
  get_Upload_Delivery() {
    this.loading = true;
    this.isload = true;
    this.Upload_Delivery_Rows = [];
    this.WTF_Printg = 0;
    this.get("Api/Invoice/get_WTF_Printing?").subscribe((res: any) => {
      this.Upload_Delivery_Rows = JSON.parse(res).record;
      this.loading = false;
      this.isload = false;
      try {
        this.WTF_Printg = this.Upload_Delivery_Rows.length;
      } catch { }

    });
  }


  public Checkout_count = 0;
  public Checkout_Visitor_Row = [];
  get_Checkout_Visitor() {


    this.Checkout_Visitor_Row = [];
    this.get("Api/Master/get_Checkout_Visitor?From=" + this.S_From + "&To=" + this.S_To + "&Visitor=" + this.S_Visitor_Type + "&Department=" + this.S_Department).subscribe((res: any) => {

      this.Checkout_Visitor_Row = JSON.parse(res).record;
      if (this.Checkout_Visitor_Row) {
        this.Checkout_count = this.Checkout_Visitor_Row.length;
      }
      else {
        this.Checkout_count = 0;
      }


    });
  }















  ledger_Filter() {

    this.SLedger_Rows = this.PLedger_Master_Rows.filter(e => e.Group_ID == this.Ledger_Type || e.Group_ID == "3");

  }








  Generate_Bill() {
    this.isload = true;
    this.get("Api/Transaction/Generate_Bill?Month=" + this.S_From + "&User=" + this.CREATED_BY).subscribe((res: any) => {
      this.isload = false;
      this.toastr.success("Generated Success");
    });
  }

  Customer_Rows = [];
  get_Customer() {
    this.getc("Api/Master/get_ledger").subscribe((res: any) => {
      this.Customer_Rows = JSON.parse(res).record;
    });
  }

  Reference_Rows = [];
  get_Reference() {

    this.isload = true;
    this.getc("Api/Master/get_reference").subscribe((res: any) => {
      this.Reference_Rows = JSON.parse(res).record;
      this.Area_Row = this.Reference_Rows.filter(e => e.Ref_ID == "Area");
      this.isload = false;
      this.get_pay_mode_ID();

    });
  }

  public Room_Master_Rows = [];
  get_rooms() {
    this.getc("Api/Master/get_rooms").subscribe((res: any) => {
      this.Room_Master_Rows = JSON.parse(res).record;


    });
  }
  public Pending_Invoice_Count = 0;

  public Pending_Invoice_Rows = [];
  get_Pending_Invoice() {
    this.loading = true;
    this.isload = true;
    this.Pending_Invoice_Rows = [];
    this.Pending_Invoice_Count = 0;

    this.get("Api/Invoice/get_Pending_Invoice?").subscribe((res: any) => {
      this.Pending_Invoice_Rows = JSON.parse(res).record;
      this.loading = false;
      this.isload = false;
      try {
        this.Pending_Invoice_Count = this.Pending_Invoice_Rows.length;
      } catch { }

    });
  }


  public DC_No = '';

  public STG_Tracking_Rows = [];
  get_STG_Tracking_Rows() {
    this.loading = true;
    this.isload = true;
    this.STG_Tracking_Rows = [];


    this.get("Api/Invoice/get_STG_Tracking_Rows?From=" + this.S_From + "&To=" + this.S_To + "&Part_No=" + this.Part_No + "&DC_No=" + this.DC_No + "&Dis_Status=" + this.Dis_Status).subscribe((res: any) => {
      this.STG_Tracking_Rows = JSON.parse(res).record;
      this.loading = false;
      this.isload = false;


    });
  }
  public Invoice_No = ""
  public Uni_Serial_No = "";

  public Job_Order_No = "";
  public Date_Type = "Packing";
  public Op_58_Report_Row = [];
  Op_58_Report() {
    this.loading = true;
    this.isload = true;
    this.Op_58_Report_Row = [];


    this.get("Api/Invoice/get_OP_58_report?From=" + this.S_From_T + "&To=" + this.S_To_T + "&Job_Order_No=" + this.Job_Order_No).subscribe((res: any) => {
      this.Op_58_Report_Row = JSON.parse(res).record;
      this.loading = false;
      this.isload = false;


    });
  }




  public Op_80_Report_Row = [];
  Op_80_Report() {
    this.loading = true;
    this.isload = true;
    this.Op_80_Report_Row = [];


    this.get("Api/Invoice/get_OP_80_report?From=" + this.S_From_T + "&To=" + this.S_To_T).subscribe((res: any) => {
      this.Op_80_Report_Row = JSON.parse(res).record;
      this.loading = false;
      this.isload = false;


    });
  }



  public Op_80B_Report_Row = [];
  Op_80B_Report() {
    this.loading = true;
    this.isload = true;
    this.Op_80B_Report_Row = [];


    this.get("Api/Invoice/get_OP_80B_report?From=" + this.S_From_T + "&To=" + this.S_To_T).subscribe((res: any) => {
      this.Op_80B_Report_Row = JSON.parse(res).record;
      this.loading = false;
      this.isload = false;


    });
  }

  Total_Qty = 0;
  Total_Rej_Qty = 0;
  Total_Rework_Qty = 0;
  public Line_Wise_Production_Details_Rows = [];

  Line_Wise_Production_Details1() {

    this.isload = true;
    this.Total_Qty = 0;
    this.Total_Rej_Qty = 0;
    this.Total_Rework_Qty = 0;
    this.Line_Wise_Production_Details_Rows = [];

    this.get("Api/Master/get_Line_Wise_Production_Details?From=" + this.S_From + "&To=" + this.S_To + "&Part_No=" + this.Part_No + "&Line_No=" + this.Line_No).subscribe((res: any) => {
      this.Line_Wise_Production_Details_Rows = JSON.parse(res).record;

      this.isload = false;

      this.Total_Qty = (this.Line_Wise_Production_Details_Rows.reduce((sum, current) => sum + parseFloat(current.Qty), 0)).toFixed();
      this.Total_Rej_Qty = (this.Line_Wise_Production_Details_Rows.reduce((sum, current) => sum + parseFloat(current.Rej_Qty), 0)).toFixed();
      this.Total_Rework_Qty = (this.Line_Wise_Production_Details_Rows.reduce((sum, current) => sum + parseFloat(current.Rework_Qty), 0)).toFixed();

    });

  }


  public Gera_Box_Incomplete_Rows = [];
  get_Gear_Box_Incomplete() {
    this.loading = true;
    this.isload = true;
    this.Gera_Box_Incomplete_Rows = [];


    this.get("Api/Invoice/get_Incomplete_Gearbox?From=" + this.S_From + "&To=" + this.S_To).subscribe((res: any) => {
      this.Gera_Box_Incomplete_Rows = JSON.parse(res).record;
      this.loading = false;
      this.isload = false;


    });
  }
  public Deleted_Details_Rows = [];
  get_Deleted_Details() {
    this.loading = true;
    this.isload = true;
    this.Deleted_Details_Rows = [];


    this.get("Api/Invoice/get_Deleted_Details?From=" + this.S_From + "&To=" + this.S_To).subscribe((res: any) => {
      this.Deleted_Details_Rows = JSON.parse(res).record;
      this.loading = false;
      this.isload = false;


    });
  }
  public Gear_Box_Dispatched_Count = 0;
  public Gera_Box_Dispatced_Rows = [];
  get_Gear_Box_Dispatced() {
    this.loading = true;
    this.isload = true;
    this.Gear_Box_Dispatched_Count = 0;
    this.Gera_Box_Dispatced_Rows = [];


    this.get("Api/Invoice/get_Gearbox_Dispatched?").subscribe((res: any) => {
      this.Gera_Box_Dispatced_Rows = JSON.parse(res).record;
      this.loading = false;
      this.isload = false;

      try {
        this.Gear_Box_Dispatched_Count = this.Gera_Box_Dispatced_Rows.length;
      } catch { }
    });
  }

  public Today_Packed_Count = 0;
  public Today_Packed_Rows = [];
  get_Today_Packed() {
    this.loading = true;
    this.isload = true;
    this.Today_Packed_Rows = [];
    this.Today_Packed_Count = 0;

    this.get("Api/Invoice/get_Today_Packed?From=" + this.S_From + "&To=" + this.S_To).subscribe((res: any) => {
      this.Today_Packed_Rows = JSON.parse(res).record;
      this.loading = false;
      this.isload = false;

      try {
        this.Today_Packed_Count = this.Today_Packed_Rows.length;
      } catch { }
    });
  }
  public WTF_Dispatched_Count = 0;
  public WTF_Dispatched_Rows = [];
  get_WTF_Dispatched() {
    this.loading = true;
    this.isload = true;
    this.WTF_Dispatched_Rows = [];
    this.WTF_Dispatched_Count = 0;

    this.get("Api/Invoice/get_WTF_Dispatched?").subscribe((res: any) => {
      this.WTF_Dispatched_Rows = JSON.parse(res).record;
      this.loading = false;
      this.isload = false;

      try {
        this.WTF_Dispatched_Count = this.WTF_Dispatched_Rows.length;
      } catch { }
    });
  }
  public WTF_Today_Dispatched_Count = 0;
  public WTF_Today_Dispatched_Rows = [];
  get_Today_Dispatched() {
    this.loading = true;
    this.isload = true;
    this.WTF_Today_Dispatched_Rows = [];
    this.WTF_Today_Dispatched_Count = 0;

    this.get("Api/Invoice/get_Today_Dispatched?From=" + this.S_From + "&To=" + this.S_To).subscribe((res: any) => {
      this.WTF_Today_Dispatched_Rows = JSON.parse(res).record;
      this.loading = false;
      this.isload = false;

      try {
        this.WTF_Today_Dispatched_Count = this.WTF_Today_Dispatched_Rows.length;
      } catch { }
    });
  }

  public Gear_Today_Dispatched_Count = 0;
  public Gear_Today_Dispatched_Rows = [];
  Today_Gearbox_Dispatched() {
    this.loading = true;
    this.isload = true;
    this.Gear_Today_Dispatched_Rows = [];
    this.WTF_Today_Dispatched_Count = 0;

    this.get("Api/Invoice/get_Gear_Box_Dispatched?From=" + this.S_From + "&To=" + this.S_To).subscribe((res: any) => {
      this.Gear_Today_Dispatched_Rows = JSON.parse(res).record;
      this.loading = false;
      this.isload = false;

      try {
        this.Gear_Today_Dispatched_Count = this.Gear_Today_Dispatched_Rows.length;
      } catch { }
    });
  }

  public Gearbox_Issue_Rows = [];
  Gearbox_Issue() {
    this.loading = true;
    this.isload = true;
    this.Gearbox_Issue_Rows = [];


    this.get("Api/Invoice/get_Gear_Box_Issue?From=" + this.S_From + "&To=" + this.S_To).subscribe((res: any) => {
      this.Gearbox_Issue_Rows = JSON.parse(res).record;
      this.loading = false;
      this.isload = false;


    });
  }
  public GearBox_OverDue_Count = 0;
  public GearBox_OverDue_Rows = [];
  Over_Due_Gearbox() {
    this.loading = true;
    this.isload = true;
    this.GearBox_OverDue_Rows = [];
    this.GearBox_OverDue_Count = 0;

    this.get("Api/Invoice/get_Gear_Box_Dispatched?From=" + this.S_From + "&To=" + this.S_To).subscribe((res: any) => {
      this.GearBox_OverDue_Rows = JSON.parse(res).record;
      this.loading = false;
      this.isload = false;

      try {
        this.GearBox_OverDue_Count = this.GearBox_OverDue_Rows.length;
      } catch { }
    });
  }
  public WTF_Packing_Count = 0;
  public WTF_Packing_Rows = [];
  get_WTF_Packing_Slip() {
    this.loading = true;
    this.isload = true;
    this.WTF_Packing_Rows = [];
    this.WTF_Packing_Count = 0;
    this.get("Api/Invoice/get_WTF_Packing_Slip?").subscribe((res: any) => {
      this.WTF_Packing_Rows = JSON.parse(res).record;
      this.loading = false;
      this.isload = false;
      try {
        this.WTF_Packing_Count = this.WTF_Packing_Rows.length;
      } catch { }
    });
  }

  public Pending_DO_Count = 0;

  public Pending_DO_Rows = [];
  get_Pending_DO() {
    this.loading = true;
    this.isload = true;
    this.Pending_DO_Rows = [];
    this.Pending_DO_Count = 0;

    this.getc("Api/Invoice/get_Pending_DO").subscribe((res: any) => {
      this.Pending_DO_Rows = JSON.parse(res).record;
      this.loading = false;
      this.isload = false;
      try {
        this.Pending_DO_Count = this.Pending_DO_Rows.length;
      } catch { }

    });
  }


  public Filter_Reprint_Row = [];
  get_Reprint_Packing_Filter(data) {
    this.loading = true;
    this.isload = true;
    this.get_Reprint_Packing_Rows = [];
    this.get("Api/Master/get_Reprint_Packing_Filter?Filter=" + data).subscribe((res: any) => {
      this.get_Reprint_Packing_Rows = JSON.parse(res).record;
      this.loading = false;
      this.isload = false;

    });
  }

  public sales_compare = "0.00";
  public sales_compare_bar = 7.00;
  public Sales_DB = [{ Date: this.Today_Date, Amount: 0, Qty: 0 }, { Date: this.Y_Date, Amount: 1, Qty: 1 }];
  get_Sales_DB() {
    this.get("Api/Invoice/get_Sales_DB?Length=7").subscribe((res: any) => {

      if (res != "[]") {
        this.Sales_DB = JSON.parse(res).record;


        if (this.Sales_DB.length == 1) {
          this.Sales_DB.push({ Date: this.Y_Date, Amount: this.Sales_DB[0]["Amount"], Qty: this.Sales_DB[0]["Qty"] });
        }

        this.sales_compare = ((((this.Sales_DB[0]["Amount"]) - this.Sales_DB[1]["Amount"]) / this.Sales_DB[1]["Amount"]) * 100).toFixed(2);
        this.sales_compare_bar = Math.abs(Number(this.sales_compare));



      }
    });

  }

  public purchase_compare = "0.00";
  public purchase_compare_bar = 7.00;
  public purchase_DB = [{ Date: this.Today_Date, Amount: 0, Qty: 0 }, { Date: this.Y_Date, Amount: 1, Qty: 1 }];
  get_purchase_DB() {
    this.get("Api/Invoice/get_Purchase_DB?Length=7").subscribe((res: any) => {

      if (res != "[]") {
        this.purchase_DB = JSON.parse(res).record;


        if (this.purchase_DB.length == 1) {
          this.purchase_DB.push({ Date: this.Y_Date, Amount: this.purchase_DB[0]["Amount"], Qty: this.purchase_DB[0]["Qty"] });
        }

        this.purchase_compare = ((((this.purchase_DB[0]["Amount"]) - this.purchase_DB[1]["Amount"]) / this.purchase_DB[1]["Amount"]) * 100).toFixed(2);
        this.purchase_compare_bar = Math.abs(Number(this.purchase_compare));



      }
    });

  }
  public Expence_compare = "0.00";
  public Expence_compare_bar = 7.00;
  public Expence_DB = [{ Date: this.Today_Date, Amount: 0, Qty: 0 }, { Date: this.Y_Date, Amount: 1, Qty: 1 }];
  get_Expence_DB() {
    this.get("Api/Invoice/get_Expence_DB?Length=7").subscribe((res: any) => {

      if (res != "[]") {
        this.Expence_DB = JSON.parse(res).record;


        if (this.Expence_DB.length == 1) {
          this.Expence_DB.push({ Date: this.Y_Date, Amount: this.Expence_DB[0]["Amount"], Qty: this.Expence_DB[0]["Qty"] });
        }

        this.Expence_compare = ((((this.Expence_DB[0]["Amount"]) - this.Expence_DB[1]["Amount"]) / this.Expence_DB[1]["Amount"]) * 100).toFixed(2);
        this.Expence_compare_bar = Math.abs(Number(this.Expence_compare));



      }
    });

  }
  public Order_DB = [{ Date: this.Today_Date, Amount: 0, Qty: 0 }, { Date: this.Y_Date, Amount: 0, Qty: 0 }];
  get_Order_DB() {

    this.get("Api/Invoice/get_Order_DB?Length=7").subscribe((res: any) => {
      if (res != "[]") {
        this.Order_DB = JSON.parse(res).record;
      }
    });
  }


  public Pending_Order_DB = [{ Pending: 0, Delivery: 0, T_Pending: 0, T_Orders: 0, Y_Orders: 0, Y_Pending: 0, Y_Delivery: 0 }];
  get_Pending_Order_DB() {

    this.getc("Api/Invoice/get_Order_DB").subscribe((res: any) => {

      if (res != "[]") {
        this.Pending_Order_DB = JSON.parse(res).record;




      }

    });
  }

  public Collection_DB = [{ Date: this.Today_Date, Amount: 0, Qty: 0 }, { Date: this.Y_Date, Amount: 0, Qty: 0 }];;
  get_Collection_DB() {
    this.get("Api/Invoice/get_Collection_DB?Length=7").subscribe((res: any) => {
      if (res != "[]") {
        this.Collection_DB = JSON.parse(res).record;

        if (this.Collection_DB.length == 1) {
          this.Collection_DB.push({ Date: this.Y_Date, Amount: 0, Qty: 1 });
        }
      }
    });
  }

  public DB_Data = [{ Sales: 0, Collection: 0, Expense: 0, Out_standing: 0 }];;
  get_DB_Data() {
    this.getc("Api/Invoice/get_DB_Data").subscribe((res: any) => {
      if (res != "[]") {
        this.DB_Data = JSON.parse(res).record;


      }
    });
  }






  Make_Delivery(Order_No) {
    this.get("Api/Invoice/Make_Delivery?Order_No=" + Order_No).subscribe((res: any) => {

      this.toastr.success("Delivered  Success..", 'Msg');
      this.back();
      this.get_Order_DB();
      this.get_Pending_Order_DB();
      this.Clear_Cart();

    });
  }






  view_Data(data) {
    this.router.navigate(['view-order-details']);
  }


  public Bank_Master_Rows = [];
  get_Bank_Master() {
    this.getc("Api/Master/get_Bank_Master").subscribe((res: any) => {
      this.Bank_Master_Rows = JSON.parse(res).record;
    });
  }

  public Oil_Type_Rows = [];
  get_Oil_Type() {
    this.getc("Api/Master/get_Oil_Type").subscribe((res: any) => {
      this.Oil_Type_Rows = JSON.parse(res).record;
    });
  }







  public Area_Street_Rows = [];
  get_Area_Street() {
    this.isload = true;

    this.getc("Api/Master/get_Area_Street_Details").subscribe((res: any) => {
      this.Area_Street_Rows = JSON.parse(res).record;
      this.isload = false;

    });

  }




  public Copy_Type = "ORIGINAL";

  public Printer_width = "58";

  Mobile_Print(data) {
    window.open(this.Server_URL + "report/Mobile_Print?User=Bill_Print&Company=" + this.Company + "&Bill_No=" + data.Bill_No + "&Format=" + this.Printer_width + "&Blue_Address=", "_blank");
  }






  public Delivery_Format = "Format1"
  Delivery_pdf(data) {
    if (this.Delivery_Format == "Format2") {
      var parm = "User=" + this.CREATED_BY + "&Company=" + this.Company + "&File_Name=" + data.Bill_No.replace(/[^a-zA-Z0-9 ]/g, "_") + "&File_Type=pdf&Bill_No=" + data.Bill_No;
      window.open(this.Server_URL + "PDF/Export_P_Invoice_1?" + parm, "_blank");
    }
    else if (this.Delivery_Format == "Format1") {
      window.open(this.Server_URL + "report/Print_Customerwise?Bill_No=" + data.Bill_No + "&Company=" + this.Company, "_blank");



    }
  }



  public Defect_Status = "All";
  public Defect_Entry_Rows = [];
  get_Defect_Entry() {
    this.Defect_Entry_Rows = [];
    this.get("Api/Master/get_Defect_Entry_Details?From=" + this.S_From + "&To=" + this.S_To + "&status=" + this.Defect_Status).subscribe((res: any) => {
      this.Defect_Entry_Rows = JSON.parse(res).record;
    });

  }


  public get_Production_Plan_Details_Rows = [];

  Production_Plan_Details() {
    this.isload = true;
    this.get_Production_Plan_Details_Rows = [];
    this.get("Api/Master/get_Pro_Plan_Details?From=" + this.S_From + "&To=" + this.S_To).subscribe((res: any) => {
      this.isload = false;
      this.get_Production_Plan_Details_Rows = JSON.parse(res).record;

    });
  }


  public Defect_Pending_Rows = [];
  get_Defect_Pending() {
    this.Defect_Pending_Rows = [];
    this.get("Api/Master/get_Defect_Pending_Details?From=" + this.S_From + "&To=" + this.S_To + "&status=" + this.Defect_Status).subscribe((res: any) => {
      this.Defect_Pending_Rows = JSON.parse(res).record;
    });
  }
  public Order_by = "All"
  public Defect_Entry_Report_Rows = [];
  public Problemwise_Report_Rows = [];
  public Responsibility_Reports_Rows = [];

  get_Defect_Entry_Report() {
    this.Defect_Entry_Report_Rows = [];
    this.get("Api/Master/get_Defect_Entry_Report?From=" + this.S_From + "&To=" + this.S_To + "&status=" + this.Defect_Status).subscribe((res: any) => {
      this.Defect_Entry_Report_Rows = JSON.parse(res).record;


      var Item = [...new Set(this.Defect_Entry_Report_Rows.map(item => item.Problem))];
      this.Problemwise_Report_Rows = [];
      for (let data of Item) {
        var count = [...new Set((this.Defect_Entry_Report_Rows.filter(e => e.Problem == data)).map(item => item.Defect_No))].length;

        this.Problemwise_Report_Rows.push({ 'Problem': data, 'count': count })


        var Item = [...new Set(this.Defect_Entry_Report_Rows.map(item => item.Responsibility))];
        this.Responsibility_Reports_Rows = [];
        for (let data of Item) {
          var count = [...new Set((this.Defect_Entry_Report_Rows.filter(e => e.Responsibility == data)).map(item => item.Defect_No))].length;

          this.Responsibility_Reports_Rows.push({ 'Responsibility': data, 'count': count })


        }
      }

    });

  }

  Summary_Row = [];
  get_Day_Summary1() {

    this.get("Api/Master/pr_get_Summary?Shift=" + this.Shift + "&Date=" + this.T_Date).subscribe((res: any) => {

      this.Summary_Row = JSON.parse(res).record;

    });
  }
  public Line_wise_oee_rows = []
  Total_Unplanned_Loss_Min = 0;
  Total_Plan = 0;
  Total_Actual = 0;
  Total_Performance = 0;
  Total_Available = 0;
  Total_Quality = 0;
  Total_OEE = 0;
  get_Lineeise_OEE() {
    this.isload = true;
    this.Total_Unplanned_Loss_Min = 0;
    this.Total_Plan = 0;
    this.Total_Actual = 0;
    this.Total_Performance = 0;
    this.Total_Available = 0;
    this.Total_Quality = 0;
    this.Total_OEE = 0;
    this.Line_wise_oee_rows = [];
    this.get("Api/Master/get_Linewise_OEE?Shift=" + this.Shift + "&Date=" + this.T_Date).subscribe((res: any) => {
      this.isload = false;
      this.Line_wise_oee_rows = JSON.parse(res).record;
      this.get_Day_Summary1()
      try {

        this.Total_Unplanned_Loss_Min = (this.Line_wise_oee_rows.reduce((sum, current) => sum + parseFloat(current.UnPlaned_Loss_Min), 0)).toFixed(0);
        this.Total_Plan = (this.Line_wise_oee_rows.reduce((sum, current) => sum + parseFloat(current.P_Plan), 0)).toFixed(0);

        this.Total_Actual = (this.Line_wise_oee_rows.reduce((sum, current) => sum + parseFloat(current.Qty), 0)).toFixed(0);

        this.Total_Performance = (this.Line_wise_oee_rows.reduce((sum, current) => sum + parseFloat(current.Performance), 0)).toFixed(0);
        this.Total_Available = (this.Line_wise_oee_rows.reduce((sum, current) => sum + parseFloat(current.Available), 0)).toFixed(0);
        this.Total_Quality = (this.Line_wise_oee_rows.reduce((sum, current) => sum + parseFloat(current.Quality), 0)).toFixed(0);
        this.Total_OEE = (this.Line_wise_oee_rows.reduce((sum, current) => sum + parseFloat(current.OEE), 0)).toFixed(0);

        this.Total_Performance = (this.Total_Performance / this.Line_wise_oee_rows.length);
        this.Total_Available = (this.Total_Available / this.Line_wise_oee_rows.length);
        this.Total_Quality = (this.Total_Quality / this.Line_wise_oee_rows.length);
        this.Total_OEE = (this.Total_OEE / this.Line_wise_oee_rows.length);
        localStorage.setItem('OEE_Per', this.Total_OEE.toFixed(0))

      } catch { }
    });
  }
  public Operator_Row;
  public Rework_details_Rows = [];
  get_Rework_Details() {
    this.isload = true;

    this.Rework_details_Rows = [];


    this.get("Api/Master/get_Rework_Details?From=" + this.S_From + "&To=" + this.S_To).subscribe((res: any) => {
      this.Rework_details_Rows = JSON.parse(res).record;
      this.isload = false;


    });

  }


  public Rework_Pending_details_Rows = [];
  get_Rework_Pending_Details() {
    this.isload = true;

    this.Rework_Pending_details_Rows = [];


    this.get("Api/Master/get_Rework_Pending_Details?").subscribe((res: any) => {
      this.Rework_Pending_details_Rows = JSON.parse(res).record;
      this.isload = false;


    });

  }

    Employee_Status = "Active"
  public Deptment_Row = [];
  get_Deptment_Details() {
    this.isload = true;
    this.Deptment_Row = [];
    this.get("Api/Master/get_Employee?Department=" + this.S_Department+"&Status="+this.Employee_Status).subscribe((res: any) => {
      this.Deptment_Row = JSON.parse(res).record;
      this.isload = false;

    });

  }
  public Defect_Entry_GF = ['Defect_No', 'Part_Code', 'Part_Name', 'Model', 'Supplier_Name'];

  public Over_Due_GF = ['Box_Barcode', 'Part_No', 'Gross_wt', 'Qty'];
  public Problemwise_Entry_GF = ['Problem'];
  public Responsibilitywise_Entry_GF = ['Responsibility'];
  public Employee_Details_Rows = [];
  get_Employee_Details() {

    this.getc("Api/Master/get_Employee_Details").subscribe((res: any) => {
      this.Employee_Details_Rows = JSON.parse(res).record;


      try {
        this.Emp_Dept = this.Employee_Details_Rows.filter(e => e.ID == this.Emp_ID)[0]["Department"];
        this.Emp_Approver = this.Employee_Details_Rows.filter(e => e.ID == this.Emp_ID)[0]["Approver_ID"];
        if (this.Emp_Approver == "" || this.Emp_Approver == "0" || this.Emp_Approver == this.Emp_ID) {
          this.Emp_Approver_Name = "";
          this.Emp_Approver = this.Emp_ID;
        }
        else {
          this.Emp_Approver_Name = this.Employee_Details_Rows.filter(e => e.ID == this.Emp_Approver)[0]["Name"];
        }
      } catch { }


    });

  }
  public Blocked_Visitor_Rows = [];
  get_Blocked_Visitor() {

    this.getc("Api/Master/get_Blocked_Visitor").subscribe((res: any) => {
      this.Blocked_Visitor_Rows = JSON.parse(res).record;
    });

  }


  public Area_Master_Rows = [];
  get_Area_Master() {

    this.isload = true;
    this.Area_Master_Rows = [];
    this.getc("Api/Master/get_Area_Master").subscribe((res: any) => {
      this.isload = false;
      this.Area_Master_Rows = JSON.parse(res).record;

    });

  }


  get_Area_Color(data) {


    try {
      return this.Area_Master_Rows.filter(e => e.Araa == data)[0]["Color_Code"];
    } catch {

      return [];
    }
  }


  public Holiday_Details_Rows = [];
  get_Holiday_Details() {

    this.getc("Api/Master/get_Holiday_Details").subscribe((res: any) => {
      this.Holiday_Details_Rows = JSON.parse(res).record;
    });

  }




  pdfType = "Open";


  get(url) {


    this.access_tocken = this.tocken;
    var reqHeader = new HttpHeaders({
      'Content-Type': 'text/plain',
      'Authorization': 'Bearer ' + this.access_tocken
    });
    



    return this.http.get(this.Server_URL + "" + url + "&Company=" + this.Company, { headers: reqHeader })
  }

  getc(url) {

    this.access_tocken = this.tocken;
    var reqHeader = new HttpHeaders({
      'Authorization': 'Bearer ' + this.access_tocken
    });

    return this.http.get(this.Server_URL + "" + url + "?Company=" + this.Company, { headers: reqHeader });
  }



  get_S(url: string, params: any) {
    const reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.access_tocken
    });
  
    return this.http.post(this.Server_URL + url, { headers: reqHeader,params });
  }


  d_get(url) {


    this.access_tocken = this.tocken;
    var reqHeader = new HttpHeaders({
      'Content-Type': 'text/plain',
      'Authorization': 'Bearer ' + this.access_tocken
    });


    return this.http.get(url + "&Company=" + this.Company, { headers: reqHeader })
  }


  public load_page(data) {
    this.router.navigate([data], { replaceUrl: true });
  }

  public load_page1(data) {
    this.router.navigate([data]);
  }
  public activeTab: any = 0;
  public load_page2(data, index) {
    this.router.navigate([data], { replaceUrl: true });
    this.activeTab = index;
  }






  post_data(data, Table) {

    data.Company = this.Company;
    data.Created_by = this.CREATED_BY;
    data.Table_Name = Table;

    
    this.isload = true;
    this.http.post(this.Server_URL + 'api/Master/Post_Data', data,  { headers: this.headers })
      .subscribe(
        (val: string) => {
          this.isload = false;
          return val;
        },
        response => {
          this.toastr.error('Error ', response, {
            timeOut: 3000
          });
          return "Error Contact Admin";
        });

    //return "Problem"
  }


head;
  public tocken = "";
  get_Token() {



    this.headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
    this.isload = true;
    this.http.post(this.Server_URL + 'token', 'grant_type=password&UserName=admin&Password=admin',  { headers: this.headers })
      .subscribe(
        (val) => {
          this.tocken = val['access_token'];

       
    
          this.head = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + this.tocken
          });

           this.headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + this.tocken
          });
        },
        response => {
          this.toastr.error('Error ', response, {
            timeOut: 3000
          });
          return "Error Contact Admin";
        });

    //return "Problem"
  }



  public length_of(dt) {

    var len = 0;
    try {
      len = dt.filteredValue.length;
      return len
    } catch { }


    if (len == 0) {
      try {
        len = dt.value.length;
      } catch { }
    }

    return len;
  }



  public sum_of(dt, field) {

    var len = 0;
    try {
      len = dt.filteredValue.length;
      return dt.filteredValue.reduce((sum, current) => sum + parseFloat(current[field]), 0);
    } catch { }


    if (len == 0) {
      try {
        len = dt.value.length;
        return dt.value.reduce((sum, current) => sum + parseFloat(current[field]), 0);
      } catch { }
    }

    return len;
  }



  Open_Modal1(Title: string, page: string) {
    this.openModal = true;
    $('#small_Module').modal('show');
  }
  public Excel_Data: any = {
    'ID': '',
    "item": '',
    "Header": '',
    "Footer": '',
    "Left_Data": '',
    "Right_Data": '',
    "Report_Name": ''

  };
  headers;

  export_excel() {

    this.Excel_Data.Company = this.Company;
    this.Excel_Data.User = this.CREATED_BY;
    

    this.http.post(this.Server_URL + 'api/master/JsontToExcel', this.Excel_Data,  { headers: this.headers })
      .subscribe(
        (val: string) => {

          if (val == "True") {

            var parm = "User=" + this.CREATED_BY + "&Company=" + this.Company + "&File_Name=" + this.File_Name + "&File_Type=xls";
            window.open(this.Server_URL + "Report/JsontToExcel?" + parm, "_blank");
            this.toastr.success("Data Exported  Successfully", 'Msg');

          }
          else {

            console.log(val);
            this.toastr.error(val, "Error", { timeOut: 3000 });
          }
        },
        response => {
          console.log(response);
          this.toastr.error('Error ', response, {
            timeOut: 3000
          });

        });

  }
  upload_excel() {

    this.Excel_Data.Company = this.Company;
    this.Excel_Data.User = this.CREATED_BY;
    

    this.http.post(this.Server_URL + 'api/master/JsontToExcel', this.Excel_Data,  { headers: this.headers })
      .subscribe(
        (val: string) => {

          if (val == "True") {

            var parm = "User=" + this.CREATED_BY + "&Company=" + this.Company + "&File_Name=" + this.File_Name + "&File_Type=xls";
            window.open(this.Server_URL + "Report/JsontToExcel_Upload?" + parm, "_blank");
            this.toastr.success("Data Exported  Successfully", 'Msg');

          }
          else {

            console.log(val);
            this.toastr.error(val, "Error", { timeOut: 3000 });
          }
        },
        response => {
          console.log(response);
          this.toastr.error('Error ', response, {
            timeOut: 3000
          });

        });

  }

  File_Name = "Data";

  export_pdf() {


    this.Excel_Data.Company_Data = JSON.parse(JSON.stringify(this.Current_User));
    this.Excel_Data.Company = this.Company;
    this.Excel_Data.User = this.CREATED_BY;

    

    this.http.post(this.Server_URL + 'api/master/JsontToExcel', this.Excel_Data,  { headers: this.headers })
      .subscribe(
        (val: string) => {

          if (val == "True") {
            var parm = "User=" + this.CREATED_BY + "&Company=" + this.Company + "&File_Name=" + this.File_Name + "&File_Type=pdf";
            window.open(this.Server_URL + "PDF/Export_Pdf?" + parm, "_blank");
            this.toastr.success("Data Exported  Successfully", 'Msg');

          }
          else {

            console.log(val);
            this.toastr.error(val, "Error", { timeOut: 3000 });
          }
        },
        response => {
          console.log(response);
          this.toastr.error('Error ', response, {
            timeOut: 3000
          });

        });

  }

  Ledger_ID = "0";
  Ledger_cr = 0;
  Ledger_db = 0;
  Ledger_Total = 0;
  Ledger_File_Name = "Data";
  public BILLNO;
  export_pdf1() {


    this.Excel_Data.Company_Data = JSON.parse(JSON.stringify(this.Current_User));
    this.Excel_Data.Company = this.Company;
    this.Excel_Data.User = this.CREATED_BY;

    this.Excel_Data.Ledger_ID = this.Ledger_ID
    this.Excel_Data.From = this.S_From;
    this.Excel_Data.To = this.S_To;
    this.Excel_Data.cr = this.Ledger_cr;

    this.Excel_Data.db = this.Ledger_db;
    this.Excel_Data.Total = this.Ledger_Total;


    

    this.http.post(this.Server_URL + 'api/master/JsontToExcel', this.Excel_Data,  { headers: this.headers })
      .subscribe(
        (val: string) => {

          if (val == "True") {
            var parm = "User=" + this.CREATED_BY + "&Company=" + this.Company + "&File_Name=" + this.File_Name + "&File_Type=pdf";
            window.open(this.Server_URL + "PDF/Export_Pdfx?" + parm, "_blank");
            this.toastr.success("Data Exported  Successfully", 'Msg');

          }
          else {

            console.log(val);
            this.toastr.error(val, "Error", { timeOut: 3000 });
          }
        },
        response => {
          console.log(response);
          this.toastr.error('Error ', response, {
            timeOut: 3000
          });

        });

  }

  encryptSecretKey = "Quickbharath";
  encryptData(data) {

    try {
      return CryptoJS.AES.encrypt(JSON.stringify(data), this.encryptSecretKey).toString();
    } catch (e) {
      console.log(e);
    }
  }

  decryptData(data) {

    try {
      const bytes = CryptoJS.AES.decrypt(data, this.encryptSecretKey);
      if (bytes.toString()) {
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      }
      return data;
    } catch (e) {
      console.log(e);
    }
  }


  /* Monitor Dashboard Admin Panel Functionality */

  isFullWidthContainer: any;
  isFullWidthCard: any;
  isFullWidthCheck: boolean = false;
  isSmallScreenIcon: boolean = true;
  isBussinessLogo: boolean;
  isLogoShow: boolean = true;

  /* Full Screen Window Functionality */

  hourlyDashboardWindow() {
    let tableZoomWindow = document.getElementById('table-window-zoom');
    const isSmallScreenIcon = document.getElementById('change-icon');
    if (document.fullscreenElement) {
      this.isFullScreen = true;
      tableZoomWindow.classList.remove('Full_Screen');
      this.isShowPlayButton = false;
      isSmallScreenIcon.classList.replace("bx-collapse", "bx-fullscreen");
      document.exitFullscreen();
    }
    else {
      this.isFullScreen = false;
      tableZoomWindow.classList.add('Full_Screen');
      this.isShowPlayButton = true;
      isSmallScreenIcon.classList.replace("bx-fullscreen", "bx-collapse");
      document.documentElement.requestFullscreen();
    }
  }
  isGetFullHourlyDashboard() {
    this.hourlyDashboardWindow();
  }
  /* Production Monitor Full with Container Functionality */
  getFullContainerWidthBox() {
    const hideGrapLayout = document.getElementById('isgraphLayout');
    let getelementId = document.getElementById('table-window-zoom');
    const isSmallScreenIcon = document.getElementById('full-container-tab');
    if (this.isFullWidthCheck == false) {
      getelementId.classList.add('hideWindowScroll');
      hideGrapLayout.classList.add('hideScroll');
      isSmallScreenIcon.classList.replace("bx-fullscreen", "bx-collapse");
      this.isFullWidthCheck = true;
    }
    else {
      hideGrapLayout.classList.remove('hideScroll');
      getelementId.classList.remove('hideWindowScroll');
      isSmallScreenIcon.classList.replace("bx-collapse", "bx-fullscreen");
      this.isFullWidthCheck = false;
    }
  }
  getCardFullWidth() {
    const hideGrapLayout = document.getElementById('isgraphLayout');
    let getelementId = document.getElementById('table-window-zoom');
    const isSmallScreenIcon = document.getElementById('full-card-tab');
    if (this.isFullWidthCard == false) {
      hideGrapLayout.classList.add('hideScroll');
      getelementId.classList.add('hideWindowScroll');
      isSmallScreenIcon.classList.replace("bx-fullscreen", "bx-collapse");
      this.isFullWidthCard = true;
    }
    else {
      hideGrapLayout.classList.remove('hideScroll');
      getelementId.classList.remove('hideWindowScroll');
      isSmallScreenIcon.classList.replace("bx-collapse", "bx-fullscreen");
      this.isFullWidthCard = false;
    }
  }
  // getFullTableWindow() {
  //   let tableZoomWindow = document.getElementById('table-window-zoom');
  //   const isSmallScreenIcon = document.getElementById('change-icon');
  //   if (document.fullscreenElement) {
  //     tableZoomWindow.classList.remove('getFullTableWindow');
  //     this.isShowPlayButton = false;
  //     isSmallScreenIcon.classList.replace("bx-collapse", "bx-fullscreen");
  //     document.exitFullscreen();
  //     this.isBussinessLogo = false;
  //     this.isLogoShow = true;
  //   }
  //   else {
  //     tableZoomWindow.classList.add('getFullTableWindow');
  //     this.isShowPlayButton = true;
  //     isSmallScreenIcon.classList.replace("bx-fullscreen", "bx-collapse");
  //     document.documentElement.requestFullscreen();
  //     this.isBussinessLogo = true;
  //     this.isLogoShow = false;
  //   }
  // }

  /* Filter Dropdown  */
  isDropdownShow() {
    this.IsFilterShow = !this.IsFilterShow;
    $('#filterPopup').modal({ backdrop: "static ", keyboard: false }, 'show');
    let isBackDrop = document.querySelector('.modal-backdrop');
    isBackDrop.classList.add('filter-modal-backdrop')
  }
  isCancelFilter() {
    $('#filterPopup').modal('hide');
  }
  isSearchFilterClose() {
    $('#filterPopup').modal('hide');
  }

  /* Generate Bg Color */
  get_color(q: any) {
    if (q === '' || q == 0) {
      return;
    }
    else if (q < 75) {
      return "#FF2511";
    }
    else if (q >= 75 && q <= 90) {
      return "#FF9636";
    }
    else {
      return "#59981A";
    }
  }
}
